"use strict";
/*
// <copyright file="ReactGrid.ts" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var $dyn;
(function ($dyn) {
    var util;
    (function (util) {
        util.controlLibraryResourcesLoaded = $dyn.observable(false);
    })(util = $dyn.util || ($dyn.util = {}));
    var ui;
    (function (ui) {
        var ListMode;
        (function (ListMode) {
            ListMode["tabular"] = "Tabular";
            ListMode["list"] = "List";
        })(ListMode = ui.ListMode || (ui.ListMode = {}));
    })(ui = $dyn.ui || ($dyn.ui = {}));
    var controls;
    (function (controls) {
        var List;
        (function (List) {
            /** Defines the mark mode given a click action in list view. */
            var MarkMode;
            (function (MarkMode) {
                /** Selects that record and unmarks all other records. */
                MarkMode[MarkMode["select"] = 0] = "select";
                /** Toggles the target record - ctrl + click or checkbox. */
                MarkMode[MarkMode["toggle"] = 1] = "toggle";
                /** Contiguous range selection. Selects the range and unselects other records - shift + click. */
                MarkMode[MarkMode["rangeSelect"] = 2] = "rangeSelect";
                /** Range expansion - ctrl + shift + click. */
                MarkMode[MarkMode["rangeExpansion"] = 3] = "rangeExpansion";
                /** Don't mark the row */
                MarkMode[MarkMode["none"] = 4] = "none";
                /** Clear marking */
                MarkMode[MarkMode["clearMark"] = 5] = "clearMark";
            })(MarkMode = List.MarkMode || (List.MarkMode = {}));
        })(List = controls.List || (controls.List = {}));
        Globalize.addCultureInfo("en", {
            messages: {
                ContextMenu_FreezeColumn: "Freeze column",
                ContextMenu_UnfreezeColumn: "Unfreeze column",
                Grid_CalculatingTotals: "Calculating totals",
                Grid_HideFooter: "Hide footer",
                Grid_HideTotal: "Hide total",
                Grid_RowProcessed: "{0} rows processed",
                Grid_ShowFooter: "Show footer",
                Grid_TotalColumn: "Total this column",
                ReactGrid_DeleteRow: "Delete row",
                ReactGrid_Discard: "Discard",
                ReactGrid_DiscardUnsaved: "Discard unsaved changes",
                ReactGrid_FollowLink: "\r\nClick to follow link'",
                ReactGrid_HideGroupHeaderLabel: "Hide group header label",
                ReactGrid_InvalidRowLink: "Go to row with issue",
                ReactGrid_PasteConfirmation: "Do you want to save your changes to this table?",
                ReactGrid_PastedTooManyColumns: "You have pasted more column values than this grid has room for. Excess column values have been ignored.",
                ReactGrid_PleaseWaitPrompt: "Please wait until all changes have been validated before working outside the table, or discard any unsaved changes and continue.",
                ReactGrid_ProvideInputLink: "Provide input here.",
                ReactGrid_ResumePrompt: "Processing has stopped because your input is needed.",
                ReactGrid_Revert: "Revert",
                ReactGrid_RowLimited: "We're unable to load any more records because you've reached the limit set by your organization. " +
                    "Please filter your data more or contact your system admin to increase this limit.",
                ReactGrid_Save: "Save",
                ReactGrid_ShowGroupHeaderLabel: "Show group header label",
                ReactGrid_UnsavedChanges: "Unsaved changes were discarded due to a data refresh. Please check your data.",
                ReactGrid_ValidationPrompt: "Some changes cannot be saved due to a validation issue. You can continue working in the table until you are ready to correct the issue.",
            },
        });
        // Properties we need to update the filter/sort classes
        var COLUMN_FILTERSORT_PROPERTIES_TO_OBSERVE = {
            IsFilterable: true,
            IsFiltered: true,
            IsSorted: true,
            SortDirection: true,
        };
        // Properties we need to recreate a column for
        var COLUMN_PROPERTIES_TO_OBSERVE = {
            AllowEdit: true,
            BackgroundColor: true,
            Enabled: true,
            ExtendedStyle: true,
            ForegroundColor: true,
            Height: true,
            HelpText: true,
            IsFrozen: true,
            IsHyperlink: true,
            Label: true,
            LookupButton: true,
            Required: true,
            ShowLabel: true,
            Skip: true,
            Visible: true,
            Width: true,
        };
        var CONTROL_SUPPORTS_DEFAULT_ACTION = {
            Date: true,
            DateTime: true,
            Input: true,
            Int64: true,
            Integer: true,
            Real: true,
            ReferenceGroup: true,
            Time: true,
            CheckBox: false,
            ComboBox: false,
            Image: false,
        };
        // Properties we need to rerender the grid for
        var GRID_PROPERTIES_TO_OBSERVE = {
            AllowEdit: true,
            ExtendedStyle: true,
            ForcePrimaryNavigation: true,
            GridLines: true,
            Height: true,
            HeightOverride: true,
            HideSelection: true,
            IsHeaderVisible: true,
            IsMarkingEnabled: true,
            IsSelectionIndicatorVisible: true,
            Mode: true,
            NavigationEnabled: true,
            VisibleRowCount: true,
            Width: true,
            WidthOverride: true,
        };
        var ADDCOLUMNBUTTONID = "AddNewColumnId";
        var FOOTERBUTTONID = "FooterButtonId";
        var GROUP_HEADER_LABEL_BUTTON_ID = "GroupHeaderLabelButton";
        var UNGROUPALLBUTTONID = "UngroupAllId";
        var FREEZING_FEATURE_NAME = "CLIGridFreezingFeature";
        var ReactList = /** @class */ (function (_super) {
            __extends(ReactList, _super);
            function ReactList(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.LayoutMinWidth = { minSizeFunction: $dyn.layout.gridLayoutMinWidth, cssClassArgument: "react-listRoot" };
                _this.LayoutMinHeight = { minSizeFunction: $dyn.layout.gridLayoutMinHeight, cssClassArgument: "react-listRoot" };
                _this.Shortcuts = __assign(__assign({}, !$dyn.UseLatestReact && { EnterInGrid: {
                        Handler: function (event) {
                            // Ignore any further shortcuts, but can't stop propagation because we need react to get the event
                            if (event.originalEvent) {
                                event.originalEvent.IgnoreShortcuts = true;
                            }
                            return false;
                        },
                        Keys: {
                            keyCode: $dyn.ui.KeyCodes.enter
                        }
                    },
                    RowChangeInGrid: {
                        Handler: function (event) {
                            // Ignore any further shortcuts, but can't stop propagation because we need react to get the event
                            if (event.originalEvent) {
                                event.originalEvent.IgnoreShortcuts = true;
                            }
                            return false;
                        },
                        Keys: {
                            isCtrlKeyAgnostic: true,
                            isShiftKeyAgnostic: true,
                            keyCode: [$dyn.ui.KeyCodes.downArrow, $dyn.ui.KeyCodes.pageDown, $dyn.ui.KeyCodes.upArrow, $dyn.ui.KeyCodes.pageUp],
                        },
                    } }), { GoToActiveRow: {
                        ChordKeys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterM },
                        Handler: function () {
                            _this.goToActiveRow();
                        },
                        Keys: { keyCode: $dyn.ui.KeyCodes.letterA },
                    } });
                /**
                 * Adds columns to list
                 */
                _this.addColumns = function () {
                    $dyn.callFunction(_this.ExecutePersonalizationCommand, _this, ["SelectForAdd"]);
                };
                _this.keyUp = function (event) {
                    // If read-only and changing row with keyboard, process row change on keyup
                    if (!$dyn.value(_this.AllowEdit) &&
                        ($dyn.util.isShortcutKeyPressed(event, {
                            isCtrlKeyAgnostic: true,
                            isShiftKeyAgnostic: true,
                            keyCode: [$dyn.ui.KeyCodes.upArrow, $dyn.ui.KeyCodes.downArrow, $dyn.ui.KeyCodes.pageUp, $dyn.ui.KeyCodes.pageDown],
                        }))) {
                        _this.syncManager.processLastQueuedRowChange();
                    }
                };
                _this.keyDown = function (event) {
                    // Note this is for web-client shortcuts since React has its own keydown handler
                    $dyn.util.handleShortcuts(_this, event);
                    if (!$dyn.UseLatestReact && _this.syncManager.RailsMode && event.originalEvent) {
                        // Ignore any further shortcuts, but can't stop propagation because we need react to get the event
                        event.originalEvent.IgnoreShortcuts = true;
                    }
                };
                /**
                 * Shows the footer
                 */
                _this.showFooter = function () {
                    _this.setFooterShown(true);
                };
                /**
                 * Requests a column total to be removed.
                 * @param columnName The name of the column total to be removed.
                 * @param complete The void, no-arg callback executed upon completion of the column total being removed.
                 */
                _this.requestRemoveTotalColumn = function (columnName, complete) {
                    _this.countsExcludedControls[columnName] = true;
                    if (Object.keys(_this.gridCountVersions).length) {
                        for (var dataSourceName in _this.gridCountVersions) {
                            if (_this.gridCountVersions.hasOwnProperty(dataSourceName)) {
                                delete _this.gridCountVersions[dataSourceName];
                                _this.gridCountVersions[dataSourceName] = function () { return true; };
                            }
                        }
                    }
                    else if (_this.gridCounts && _this.gridCounts.ColumnCounts) {
                        // Note: we need to copy the grid counts vs. modifying the existing counts as the component retains
                        // the previous object instance as it's (previous) props
                        _this.gridCounts = $dyn.util.objectAssign({}, _this.gridCounts, { ColumnCounts: _this.getEmptyColumnCounts() });
                    }
                    _this.postRenderCallbacks.push(function () {
                        complete && complete();
                        _this.updateColumnTotalShown(columnName, false);
                    });
                    _this.renderReactListAsync();
                };
                /**
                 * Requests a column to be added as a total.
                 * @param columnName The name of the column to be added as a total.
                 * @param complete The void, no-arg callback executed upon completion of the column being added as a total.
                 * @param options Additional options to control request behavior.
                 */
                _this.requestAddTotalColumn = function (columnName, complete, options) {
                    if (options === void 0) { options = { performRender: true }; }
                    delete _this.countsExcludedControls[columnName];
                    if (Object.keys(_this.gridCountVersions).length) {
                        for (var dataSourceName in _this.gridCountVersions) {
                            if (_this.gridCountVersions.hasOwnProperty(dataSourceName)) {
                                delete _this.gridCountVersions[dataSourceName];
                                _this.gridCountVersions[dataSourceName] = function () { return true; };
                            }
                        }
                    }
                    else if (_this.gridCounts && _this.gridCounts.ColumnCounts) {
                        // Note: we need to copy the grid counts vs. modifying the existing counts as the component retains
                        // the previous object instance as it's (previous) props
                        _this.gridCounts = $dyn.util.objectAssign({}, _this.gridCounts, { ColumnCounts: _this.getEmptyColumnCounts() });
                    }
                    if (options.performRender) {
                        _this.postRenderCallbacks.push(function () {
                            complete && complete();
                            _this.updateColumnTotalShown(columnName, true);
                        });
                        _this.renderReactListAsync();
                    }
                    else {
                        _this.updateColumnTotalShown(columnName, true);
                    }
                };
                /**
                 * Requests grid totals, further requesting all data.
                 * @param complete The void, no-arg callback executed upon completion of count calculations.
                 */
                _this.requestTotals = function (complete) {
                    var setGridCounts = function () {
                        _this.gridCounts = {
                            ColumnCounts: _this.getCalculatedColumnCounts(),
                            IsPartialCount: !!_this.IsSizeLimited(),
                            MarkedRowCount: _this.gridCounts && _this.gridCounts.MarkedRowCount,
                            RowCount: _this.DisplayRowCount(),
                        };
                        _this.postRenderCallbacks.push(complete);
                        _this.renderReactListAsync();
                        _this.telemetryEventArgs.totals = $dyn.telemetry.addControlActionEvent(_this, _this.telemetryEventArgs.totals, $dyn.telemetry.ActionEvents.gridRequestTotals, {}, true);
                        if (_this.createdRetreivalDialog) {
                            // Close the data retreival dialog
                            $dyn.shell.dialogBack();
                            _this.createdRetreivalDialog = false;
                        }
                    };
                    // If the grid has any column counts or if any controls are excluded, then there is an aptitude for counts
                    // and data should be retrieved; otherwise there is no point in retrieval data since there are no counts
                    // possible.
                    if (Object.keys(_this.gridCounts.ColumnCounts).length || Object.keys(_this.countsExcludedControls).length) {
                        if (_this.MayHaveMoreDataAboveOrBelow()) {
                            _this.createRetreivalDialog(complete);
                            _this.getAllData(setGridCounts);
                        }
                        else {
                            setGridCounts();
                        }
                    }
                    else {
                        complete && complete();
                    }
                };
                /**
                 * Requests group subtotals
                 * @param complete The void, no-arg callback executed upon completion of data retrieval
                 */
                _this.requestGroupTotals = function (rowIndex, complete) {
                    var totallingGroupTrackingId = _this.groupingManager.getTrackingIdFromRowIndex(rowIndex);
                    var pageRetrieved = function () {
                        if (_this.retrievingGroupData) {
                            $dyn.setValue(_this, "dataRetrievalProgressText", $dyn.format($dyn.label("Grid_RowProcessed"), $dyn.length(_this.DataSource)));
                            window.setTimeout(function () { _this.furtherRequestGroupTotals(totallingGroupTrackingId, complete); });
                        }
                    };
                    // First group header will have rowindex of 0 so check and see if 0 and if so get previous page
                    // else it must be last group header so get nextpage instead
                    if (!_this.retrievingGroupData) {
                        _this.retrievingGroupData = true;
                        _this.createRetreivalDialog(complete);
                        if (_this.groupingManager.isFirstGroup(totallingGroupTrackingId)) {
                            window.setTimeout(function () { _this.getPreviousPage(null, pageRetrieved); });
                        }
                        else if (_this.groupingManager.isLastGroup(totallingGroupTrackingId)) {
                            window.setTimeout(function () { _this.getNextPage(null, pageRetrieved); });
                        }
                    }
                };
                _this.freezeColumn = function (columnToFreeze, value) {
                    var e_1, _a;
                    var columnToFreezeOptions = _this.getColumnInfo(columnToFreeze);
                    if (columnToFreezeOptions) {
                        $dyn.callFunction(columnToFreezeOptions.ExecutePersonalizationCommand, columnToFreezeOptions, ["SelectForMove"]);
                        var positionStr = _this.Name + ",";
                        var lastFrozenColumn = "";
                        try {
                            for (var _b = __values(_this.columnInfo), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var columnOptions = _c.value;
                                if (columnOptions && columnToFreezeOptions._name !== columnOptions._name) {
                                    if ($dyn.value(columnOptions.IsFrozen)) {
                                        lastFrozenColumn = columnOptions._name;
                                    }
                                    else {
                                        break;
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        if (lastFrozenColumn) {
                            positionStr += lastFrozenColumn;
                        }
                        $dyn.callFunction(columnToFreezeOptions.ExecutePersonalizationCommand, columnToFreezeOptions, ["MoveControl", positionStr]);
                        $dyn.callFunction(columnToFreezeOptions.UpdateIsFrozen, columnToFreezeOptions, [value]);
                    }
                };
                _this.changeRow = function (rowIndex, activeColumnName, libMarkMode, inputMode) {
                    var previousTrackingId = $dyn.value(_this.InternalSelectedRowTrackingId);
                    var previousIndex = _this.getRowIndexFromTrackingId(previousTrackingId);
                    if (rowIndex === previousIndex || rowIndex < 0) {
                        // if previous row and new row are the same or we get an invalid row index do nothing
                        return rowIndex;
                    }
                    var markMode = libMarkMode;
                    var dataSource = $dyn.value(_this.DataSource);
                    var isServerBound = $dyn.isServerBoundDataSource(_this.DataSource);
                    var masterTrackingId = _this.getTrackingIdFromRowIndex(rowIndex);
                    var collectionIndex = _this.groupingManager.rowIndexToCollectionIndex(rowIndex);
                    var isGroupHeader = _this.groupingManager.isGroupHeader(rowIndex);
                    if (!isGroupHeader) {
                        // If we are changing rows, we need to make sure that we clear any current active group header
                        _this.groupingManager.clearActiveGroup();
                    }
                    var groupMarkingInfo;
                    if (isGroupHeader) {
                        if (markMode === $dyn.controls.List.MarkMode.select) {
                            markMode = $dyn.controls.List.MarkMode.clearMark;
                        }
                        else if (markMode === $dyn.controls.List.MarkMode.rangeSelect || markMode === $dyn.controls.List.MarkMode.rangeExpansion) {
                            markMode = $dyn.controls.List.MarkMode.none;
                        }
                        else if (markMode === $dyn.controls.List.MarkMode.toggle) {
                            var groupStartIndex = _this.groupingManager.getGroupStartIndex(masterTrackingId);
                            var groupEndIndex = _this.groupingManager.getGroupEndIndex(masterTrackingId);
                            var groupMarkingValue = _this.groupingManager.getGroupHeaderData(rowIndex, $dyn.reactGrid.ISMARKED_NAME);
                            var newIsMarked = (groupMarkingValue === 1 /* checked */) ? false : true;
                            groupMarkingInfo = {
                                endIndex: groupEndIndex,
                                newIsMarked: newIsMarked,
                                startIndex: groupStartIndex,
                            };
                        }
                    }
                    else {
                        if (markMode !== $dyn.controls.List.MarkMode.select && markMode !== $dyn.controls.List.MarkMode.none &&
                            (parseInt(masterTrackingId, 10) < 0 || _this.syncManager.hasDataInteractions() || _this.syncManager.IsPaused)) {
                            // Have to wait until client is caught up to use multiselect
                            // going to negative tracking id means going to client created row
                            markMode = $dyn.controls.List.MarkMode.select;
                        }
                    }
                    var previousCollectionIndex = _this.groupingManager.rowIndexToCollectionIndex(previousIndex);
                    var previousIsGroupHeader = _this.groupingManager.isGroupHeader(previousIndex);
                    // By default the range pivot is the previous row, unless there was an existing range selection
                    var rangePivot = previousTrackingId;
                    var pivotIndex = previousIndex;
                    var isRangePivotGroupHeader = previousIsGroupHeader;
                    var pivotCollectionIndex = previousCollectionIndex;
                    if (_this.rangeSelection) {
                        var forceClearRangeSeletion = false;
                        if (_this.rangePivotTrackingId) {
                            var cachedRangePivot_rowIndex = _this.getRowIndexFromTrackingId(_this.rangePivotTrackingId);
                            if (cachedRangePivot_rowIndex > -1) {
                                rangePivot = _this.rangePivotTrackingId;
                                pivotIndex = cachedRangePivot_rowIndex;
                                isRangePivotGroupHeader = _this.groupingManager.isGroupHeader(pivotIndex);
                                pivotCollectionIndex = _this.groupingManager.rowIndexToCollectionIndex(pivotIndex);
                            }
                            else {
                                forceClearRangeSeletion = true;
                            }
                        }
                        else {
                            forceClearRangeSeletion = true;
                        }
                        // Edge case: the saved range pivot is no longer valid
                        if (forceClearRangeSeletion) {
                            _this.clearRangeSelection();
                        }
                    }
                    if (isRangePivotGroupHeader) {
                        // Need to send the server a pivot index it understands
                        var groupStartIndex = _this.groupingManager.getGroupStartIndex(rangePivot);
                        if (rowIndex > pivotIndex) {
                            pivotCollectionIndex = groupStartIndex;
                            if (pivotCollectionIndex === collectionIndex && groupStartIndex > 0) {
                                pivotCollectionIndex = groupStartIndex - 1;
                            }
                        }
                        else {
                            pivotCollectionIndex = groupStartIndex - 1;
                        }
                        rangePivot = _this.getTrackingIdFromCollectionIndex(pivotCollectionIndex);
                    }
                    if (_this.preemptiveClient) {
                        if (isGroupHeader) {
                            if (isServerBound) {
                                _this.DataSource.__boundDataSource.internalActiveMasterTrackingId(masterTrackingId);
                            }
                            else {
                                if (dataSource[previousCollectionIndex] && !previousIsGroupHeader) {
                                    dataSource[previousCollectionIndex][$dyn.reactGrid.ISSELECTED_NAME] = false;
                                }
                                $dyn.setValue(_this, "InternalSelectedRowTrackingId", masterTrackingId);
                            }
                        }
                        else {
                            if (isServerBound) {
                                _this.setActiveRowCollectionIndex(collectionIndex);
                                _this.setClientMarking(true);
                            }
                            else {
                                if (dataSource[collectionIndex]) {
                                    dataSource[collectionIndex][$dyn.reactGrid.ISSELECTED_NAME] = true;
                                }
                                if (dataSource[previousCollectionIndex] && !previousIsGroupHeader) {
                                    dataSource[previousCollectionIndex][$dyn.reactGrid.ISSELECTED_NAME] = false;
                                }
                                $dyn.setValue(_this, "InternalSelectedRowTrackingId", masterTrackingId);
                            }
                        }
                        // Update Marking
                        // Note: We don't currently handle if the server call fails
                        switch (markMode) {
                            case $dyn.controls.List.MarkMode.select:
                                // Unmark all marked records except the record at collectionIndex
                                if (previousCollectionIndex > -1 && dataSource[previousCollectionIndex] && _this.getRowMark(previousCollectionIndex, isServerBound)) {
                                    _this.setRowMark(previousCollectionIndex, false, isServerBound);
                                }
                                if (isServerBound && _this.getMarkedRowCount() === 0) { // Optimization for when we don't need to unmark any other records
                                    _this.setRowMark(collectionIndex, true, isServerBound);
                                }
                                else {
                                    for (var index = 0; index < $dyn.length(dataSource); index++) {
                                        // Only the record at rowIndex should be marked
                                        _this.setRowMark(index, (index === collectionIndex), isServerBound);
                                    }
                                }
                                _this.clearRangeSelection();
                                break;
                            case $dyn.controls.List.MarkMode.toggle:
                                if (isGroupHeader) {
                                    for (var i = groupMarkingInfo.startIndex; i <= groupMarkingInfo.endIndex; i++) {
                                        _this.setRowMark(i, groupMarkingInfo.newIsMarked, isServerBound);
                                    }
                                }
                                else {
                                    _this.setRowMark(collectionIndex, !_this.getRowMark(collectionIndex, isServerBound), isServerBound);
                                }
                                break;
                            case $dyn.controls.List.MarkMode.rangeSelect:
                                if (!_this.rangeSelection) {
                                    _this.rangeSelection = true;
                                    _this.rangePivotTrackingId = previousTrackingId;
                                }
                            case $dyn.controls.List.MarkMode.rangeExpansion:
                                var startIndex = void 0;
                                var endIndex = void 0;
                                if (pivotCollectionIndex > collectionIndex) {
                                    startIndex = collectionIndex;
                                    endIndex = pivotCollectionIndex;
                                }
                                else {
                                    startIndex = pivotCollectionIndex;
                                    endIndex = collectionIndex;
                                }
                                if (markMode === $dyn.controls.List.MarkMode.rangeSelect) {
                                    // Unmark all marked records except records in the range
                                    for (var index = 0; index < $dyn.length(dataSource); index++) {
                                        _this.setRowMark(index, (index >= startIndex && index <= endIndex), isServerBound);
                                    }
                                }
                                else { // markMode === $dyn.controls.List.MarkMode.rangeExpansion
                                    // Only change isMarked within the expansion range (don't unmark)
                                    for (var i = startIndex; i <= endIndex; i++) {
                                        _this.setRowMark(i, true, isServerBound);
                                    }
                                }
                                break;
                            case $dyn.controls.List.MarkMode.clearMark:
                                // Unmark all marked records
                                if (previousCollectionIndex > -1 && _this.getRowMark(previousCollectionIndex, isServerBound)) {
                                    _this.setRowMark(previousCollectionIndex, false, isServerBound);
                                }
                                if (!isServerBound || _this.getMarkedRowCount() > 0) { // Optimization for when we don't need to unmark any other records
                                    for (var i = 0; i < $dyn.length(dataSource); i++) {
                                        _this.setRowMark(i, false, isServerBound);
                                    }
                                }
                                _this.clearRangeSelection();
                                break;
                        }
                        // Re-render
                        _this.markedSelectedVersion++;
                        _this.renderReactListSync();
                    }
                    // Don't queue row change for group headers
                    if (isGroupHeader) {
                        if (markMode === $dyn.controls.List.MarkMode.toggle) {
                            var startTrackingId = _this.getTrackingIdFromCollectionIndex(groupMarkingInfo.startIndex);
                            var endTrackingId = _this.getTrackingIdFromCollectionIndex(groupMarkingInfo.endIndex);
                            if (isServerBound && _this.preemptiveClient) {
                                _this.setClientMarking(true);
                            }
                            _this.syncManager.markGroup(startTrackingId, endTrackingId, groupMarkingInfo.newIsMarked);
                        }
                        else if (markMode === $dyn.controls.List.MarkMode.clearMark) {
                            if (isServerBound && _this.preemptiveClient) {
                                _this.setClientMarking(true);
                            }
                            // Need to tell server to unmark rows
                            _this.syncManager.unmarkAll();
                        }
                        _this.syncManager.queueSaveIfNeeded();
                    }
                    else {
                        _this.syncManager.changeRow(masterTrackingId, markMode, rangePivot, inputMode, activeColumnName);
                    }
                    // did mouse click come here
                    if (inputMode === $dyn.ui.InputType.mouse) {
                        _this.formActiveRowChangedNotify();
                    }
                    return rowIndex;
                };
                _this.getRowData = function (rowIndex, columnKey, dataSourceName) {
                    if (rowIndex < 0 || rowIndex >= $dyn.length(_this.DataSource) + _this.groupingManager.collectionLengthOffset()) {
                        $dyn.log.reactList && $dyn.log.reactList("ReactList: Trying to get data for invalid row index");
                        return;
                    }
                    if (_this.groupingManager.isGroupHeader(rowIndex)) {
                        return _this.groupingManager.getGroupHeaderData(rowIndex, columnKey, dataSourceName);
                    }
                    var collectionIndex = _this.groupingManager.rowIndexToCollectionIndex(rowIndex);
                    return _this.getCollectionData(collectionIndex, columnKey, dataSourceName);
                };
                _this.getGridOptions = function () {
                    if (!_this.gridOptions) {
                        _this.gridOptions = [];
                        var currentTheme = $dyn.ui.theme.get();
                        var buttonStyle = {
                            ":hover": {
                                backgroundColor: currentTheme.appBarPressed,
                            },
                            backgroundColor: "transparent",
                            borderColor: "transparent",
                            color: currentTheme.fieldTextColor,
                            font: currentTheme.defaultFont,
                        };
                        if ($dyn.value(_this.AllowPersonalization) && _this.Root && $dyn.value(_this.Root.AllowExplicitPersonalization) && !_this.Root.isPopup()) {
                            _this.gridOptions.push(_this.getAddColumnButton(buttonStyle));
                        }
                        _this.gridOptions.push(_this.getFooterButton(buttonStyle));
                        if (_this.groupingManager.hasGrouping()) {
                            _this.gridOptions.push(_this.getGroupHeaderLabelButton(buttonStyle));
                            _this.gridOptions.push(_this.getUngroupAllButton(buttonStyle));
                        }
                    }
                    return _this.gridOptions;
                };
                _this.ungroupAll = function () {
                    _this.groupingManager.group(null);
                };
                _this.toggleGroupHeaderLabel = function () {
                    _this.resetGroupingGridOptions();
                    $dyn.callFunction(_this.UpdateShowGroupHeaderLabel, _this, [!$dyn.value(_this.ShowGroupHeaderLabel)]);
                };
                _this.onKeyDown = function (event, columnProps) {
                    // if the propagation is not stopped, then continue with processing
                    if (!event.isPropagationStopped || !event.isPropagationStopped()) {
                        if ($dyn.util.isShortcutKeyPressed(event.nativeEvent, { ctrl: true, keyCode: $dyn.ui.KeyCodes.f10 })) {
                            $dyn.contextMenu.openContextMenuHandler(event.nativeEvent, true);
                            event.stopPropagation && event.stopPropagation();
                        }
                        else if ($dyn.util.isShortcutKeyPressed(event.nativeEvent, { alt: true, keyCode: $dyn.ui.KeyCodes.upArrow })) {
                            _this.previewValue = columnProps.Value;
                            $dyn.shell.previewManager.enhancedPreviewShortcutHandler(_this.getLiveControl(event.target), event.nativeEvent);
                            event.stopPropagation && event.stopPropagation();
                        }
                        else if ($dyn.util.isShortcutKeyPressed(event.nativeEvent, { keyCode: $dyn.ui.KeyCodes.enter })) {
                            var navigationActionCalled = _this.performKeyDownNavigationAction(_this.getLiveControl(event.target), event);
                            _this.formActiveRowChangedNotify();
                            if (!$dyn.UseLatestReact && !navigationActionCalled) {
                                // Need timeout because you can't dispatch an event while its being dispatched
                                window.setTimeout(function () {
                                    if (event.nativeEvent && event.nativeEvent.IgnoreShortcuts) {
                                        event.nativeEvent.IgnoreShortcuts = false;
                                        if (_this.element && _this.element.parentElement) {
                                            // Synthetic event bubbled through react tree, so now dispatch the native event on the parent element
                                            // so the native event can now bubble through the DOM
                                            try {
                                                _this.element.parentElement.dispatchEvent(event.nativeEvent);
                                            }
                                            catch (e) {
                                                // Special handler for IE11
                                                if (e.message === "NotSupportedError") {
                                                    var ieEvent = document.createEvent("KeyboardEvent");
                                                    ieEvent.initKeyboardEvent("keydown", true, true, null, event.nativeEvent.key, 0, "", false, "");
                                                    _this.element.parentElement.dispatchEvent(ieEvent);
                                                }
                                            }
                                        }
                                    }
                                });
                                event.persist();
                            }
                        }
                    }
                };
                _this.lastRowArrowDown = function (column, markMode) {
                    if ($dyn.value(_this.AllowCreateOnKeyDown)) {
                        // Need to get selected row before it is updated to the newly created client row
                        var rangePivot = $dyn.value(_this.InternalSelectedRowTrackingId);
                        var formId_1 = _this.Root && _this.Root.Id;
                        var clientTrackingId_1 = "-1";
                        if ($dyn.isServerBoundDataSource(_this.DataSource)) {
                            clientTrackingId_1 = _this.DataSource.__boundDataSource.generateClientTrackingId().toString();
                            var lastGroupTrackingId = "";
                            var lastCollectionIndex = $dyn.length(_this.DataSource.__boundDataSource.items) - 1;
                            var lastItem = _this.DataSource.__boundDataSource.items()[lastCollectionIndex];
                            lastGroupTrackingId = lastItem.getValue($dyn.reactGrid.PARENT_GROUP_KEY);
                            var masterCollectionId_1 = _this.DataSource.__boundDataSource.id;
                            var newRow_1;
                            _this.modelCollectionIds.forEach(function (collectionId) {
                                var modelItem = {
                                    Id: clientTrackingId_1,
                                    Item: {
                                        Id: clientTrackingId_1,
                                        Properties: {
                                            _RESERVED_ForceEdit: true,
                                            MasterTrackingId: clientTrackingId_1,
                                        },
                                    },
                                };
                                var collection = $dyn.serverForm.ModelManager.getModelCollection(collectionId, formId_1);
                                collection.clientMarking = true;
                                $dyn.value(collection.items)[$dyn.length(collection.items) - 1].isSelected = false;
                                $dyn.value(collection.items)[$dyn.length(collection.items) - 1].isMarked = false;
                                var newModel = collection.deserializeModel(modelItem, $dyn.length(collection.items), formId_1);
                                collection.numberOfClientRows++;
                                if ($dyn.isObservableArray(collection.items)) {
                                    collection.items.push(newModel);
                                }
                                newModel.isSelected = true;
                                newModel.isMarked = false;
                                if (collectionId === masterCollectionId_1) {
                                    newRow_1 = newModel;
                                }
                            });
                            if (newRow_1 && lastGroupTrackingId) {
                                _this.groupingManager.addNewRow(newRow_1, lastGroupTrackingId);
                            }
                            _this.markedSelectedVersion++;
                            _this.dataVersion++;
                            if (_this.ControlLibGridRef) {
                                _this.ControlLibGridRef.recalculateScrollTop();
                            }
                            // Need to render async so the recalculateScrollTop setState call is finished
                            _this.renderReactListAsync();
                            var colToFocus = _this.firstPotentialEditableColumn();
                            if (colToFocus) {
                                if (_this.Root && _this.Root.ActiveControl) {
                                    _this.Root.ActiveControl(colToFocus);
                                }
                                if (_this.ControlLibGridRef && colToFocus !== _this.activeColumnName) {
                                    _this.ControlLibGridRef.focusColumn(colToFocus);
                                }
                            }
                        }
                        _this.syncManager.createRow(clientTrackingId_1, markMode, rangePivot, column);
                    }
                };
                _this.mouseEnter = function (event, columnProps) {
                    // Don't show preview when personalizing
                    if ($dyn.value($dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode)) {
                        return;
                    }
                    var collectionIndex = _this.groupingManager.rowIndexToCollectionIndex(columnProps.RowIndex);
                    var model = $dyn.value(_this.DataSource)[collectionIndex];
                    if (model) {
                        if ($dyn.isServerBoundDataSource(_this.DataSource)) {
                            _this.previewTrackingId = model.masterTrackingId;
                            var trackingIdAsNum = parseInt(_this.previewTrackingId, 10);
                            if (isNaN(trackingIdAsNum) || trackingIdAsNum < 0) {
                                // invalid tracking id or going to client created row
                                return;
                            }
                        }
                        else {
                            _this.previewTrackingId = model.MasterTrackingId;
                        }
                    }
                    if (columnProps.Type === "ImageEdit" || columnProps.Type === "ImageEditCell") {
                        _this.previewValue = columnProps.EncodedData;
                    }
                    else {
                        _this.previewValue = columnProps.Value;
                    }
                    _this.previewControlIsValid = columnProps.Validity ? columnProps.Validity.valid : true;
                    var controlElement = $(event.target).addBack().closest("[data-dyn-controlname]")[0];
                    $dyn.preview.tryOpenPreview(controlElement, event.nativeEvent);
                };
                _this.mouseLeave = function (event, columnProps) {
                    _this.previewTrackingId = undefined;
                    _this.previewValue = undefined;
                    _this.previewControlIsValid = undefined;
                    var controlElement = $(event.target).addBack().closest("[data-dyn-controlname]")[0];
                    if (!controlElement) {
                        // aria-index is 1 based and includes the header row
                        var ariaRowIndex = columnProps.RowIndex + 1;
                        if ($dyn.value(_this.IsHeaderVisible)) {
                            ariaRowIndex++;
                        }
                        controlElement = $(_this.element).find("[aria-rowindex=" + ariaRowIndex + "] [data-dyn-controlname='" + columnProps.Name + "']")[0];
                    }
                    $dyn.preview.tryClosePreview(controlElement, event.nativeEvent);
                };
                _this.columnMouseEnter = function (event) {
                    $dyn.superTooltip.tryOpenSuperTooltip(event.target);
                };
                _this.columnFocus = function (event, columnName) {
                    _this.activeColumnName = columnName;
                };
                _this.onPaste = function (event) {
                    var e_2, _a;
                    if (!$dyn.value(_this.AllowEdit) || !$dyn.value(_this.Enabled)) {
                        return;
                    }
                    // Only continue if there is clipboard data
                    if (event.clipboardData) {
                        // Retrieve the text from the clipboard
                        var pasteValues = event.clipboardData.getData("text") || "";
                        // Split paste data by newlines that are not within double quotes.
                        // Pasted excel data tends to end in a newline, so pop the final element if that's the case
                        var rows = pasteValues.split(/\r?\n(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/g);
                        var lastValue = rows[rows.length - 1].toString().trim();
                        if (lastValue === "") {
                            rows.pop();
                        }
                        // Simply paste if there are no new lines or tabs or pasting into a text area
                        if (rows.length <= 0 ||
                            (rows.length === 1 && rows[0].indexOf("\t") === -1) ||
                            (event.target && event.target.type === "textarea")) {
                            return;
                        }
                        // Perform setup before working with first value
                        event.preventDefault && event.preventDefault();
                        if ((_this.getActiveRowCollectionIndex() + rows.length >= $dyn.length(_this.DataSource)) &&
                            $dyn.value(_this.HasNextPage)) {
                            // If pasting more data than we have rows, and we have more data to get
                            // get the next page before performing the paste
                            _this.getNextPage(null, function () { return _this.onPaste(event); });
                            return;
                        }
                        _this.telemetryEventArgs.pasteFromExcel = $dyn.telemetry.addControlActionEvent(_this, _this.telemetryEventArgs.pasteFromExcel, $dyn.telemetry.ActionEvents.gridPasteFromExcel, {}, true);
                        _this.syncManager.IsPaused = true;
                        _this.syncManager.RailsMode = true;
                        // Retrieve starting column index
                        var startingColIndex = _this.columnNameToInfoIndex[_this.activeColumnName];
                        var rowIndex = _this.getRowIndexFromTrackingId($dyn.value(_this.InternalSelectedRowTrackingId));
                        var origRowIndex = rowIndex;
                        var tooManyPastedColumns = false;
                        for (var i = 0; i < rows.length; i++) {
                            // skip over group header rows (expand any collapsed groups we run into)
                            if (_this.groupingManager.isGroupHeader(rowIndex)) {
                                if (_this.groupingManager.getGroupIsCollapsed(_this.getTrackingIdFromRowIndex(rowIndex))) {
                                    _this.groupingManager.toggleGroupExpandCollapse(rowIndex);
                                }
                                _this.changeRow(++rowIndex, _this.columnInfo[startingColIndex].DataSourceName, 4 /* none */, $dyn.ui.InputType.keyboard);
                            }
                            var row = rows[i];
                            var values = row.split("\t");
                            var colIndexOffset = 0;
                            var refGroupChildIndex = 0;
                            try {
                                for (var values_1 = (e_2 = void 0, __values(values)), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                                    var value_1 = values_1_1.value;
                                    var colIndex = startingColIndex + colIndexOffset;
                                    if (colIndex < _this.columnInfo.length) {
                                        var colInfo = _this.columnInfo[colIndex];
                                        var moveToNextCol = true;
                                        if (colInfo.TypeName === "ReferenceGroup") {
                                            moveToNextCol = false;
                                            colInfo.ChildCols[refGroupChildIndex].pasteFromExcel(value_1, { RowIndex: rowIndex });
                                            refGroupChildIndex++;
                                            if (refGroupChildIndex >= $dyn.length(colInfo.ChildCols)) {
                                                colInfo.pasteFromExcel({ RowIndex: rowIndex });
                                                refGroupChildIndex = 0;
                                                moveToNextCol = true;
                                            }
                                        }
                                        else if (colInfo.pasteFromExcel) {
                                            if (colInfo.TypeName === "MultilineInput" &&
                                                value_1.length > 2 &&
                                                value_1[0] === '"' && value_1.indexOf("\n") !== -1 && value_1[value_1.length - 1] === '"') {
                                                // Get rid of the quotes that excel adds around a value with a newline char
                                                value_1 = value_1.substring(1, value_1.length - 1);
                                            }
                                            colInfo.pasteFromExcel(value_1, { RowIndex: rowIndex });
                                        }
                                        if (moveToNextCol) {
                                            colIndexOffset++;
                                        }
                                    }
                                    else {
                                        tooManyPastedColumns = true;
                                        break;
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            // Moving to next row
                            if (i < rows.length - 1) {
                                var collectionIndex = _this.groupingManager.rowIndexToCollectionIndex(rowIndex);
                                if (collectionIndex < $dyn.length(_this.DataSource) - 1) {
                                    _this.changeRow(++rowIndex, _this.columnInfo[startingColIndex].DataSourceName, 4 /* none */, $dyn.ui.InputType.keyboard);
                                }
                                else {
                                    // Create new row if allowed
                                    if ($dyn.value(_this.AllowCreateOnKeyDown)) {
                                        _this.lastRowArrowDown(_this.columnInfo[startingColIndex].Name, $dyn.controls.List.MarkMode.none);
                                        rowIndex++;
                                    }
                                    else {
                                        break;
                                    }
                                }
                            }
                        }
                        // Move focus to where they pasted from
                        _this.changeRow(origRowIndex, _this.columnInfo[startingColIndex].DataSourceName, 4 /* none */, $dyn.ui.InputType.keyboard);
                        _this.dataVersion++;
                        _this.renderReactListAsync();
                        if (tooManyPastedColumns) {
                            $dyn.warn({ Message: $dyn.label("ReactGrid_PastedTooManyColumns") }, _this);
                        }
                        _this.syncManager.showPastePrompt();
                    }
                };
                _this.onRowClicked = function (event, rowIndex, columnName) {
                    // Do not allow the grid to mark the row if it is selected and unmarked, if executing a hyperlink or jump ref
                    var allowMarkOnRowClick = true;
                    if ($dyn.value(_this.Enabled) && $dyn.value(_this.NavigationAction)) {
                        var callExecuteAction = false;
                        if (!$dyn.value(_this.AllowEdit) && $dyn.value(_this.ForcePrimaryNavigation)) {
                            callExecuteAction = true;
                            allowMarkOnRowClick = false;
                        }
                        else if ($dyn.value(_this.NavigationEnabled) && (_this.IsCardList() || columnName === _this.defaultControlName)) {
                            if (_this.IsCardList()) {
                                callExecuteAction = true;
                            }
                            allowMarkOnRowClick = false;
                        }
                        if (callExecuteAction) {
                            _this.executeAction(rowIndex);
                            if (event) {
                                $dyn.log.stopPropagation && $dyn.log.stopPropagation("ReactGrid - onRowClicked");
                                event.stopPropagation && event.stopPropagation();
                                event.preventDefault && event.preventDefault();
                            }
                        }
                    }
                    if (allowMarkOnRowClick) {
                        var activeColumn = _this.getColumnInfo(columnName);
                        if (activeColumn && $dyn.value(activeColumn.IsHyperlink)) {
                            allowMarkOnRowClick = true;
                        }
                    }
                    return allowMarkOnRowClick;
                };
                _this.executeAction = function (rowIndex) {
                    if (_this.syncManager.RailsMode) {
                        // Do not want to navigate away if rails mode is on
                        return;
                    }
                    var masterTrackingId;
                    if (rowIndex !== undefined) {
                        masterTrackingId = _this.getTrackingIdFromRowIndex(rowIndex);
                    }
                    _this.dataCache.turnOffFastFetch();
                    var activeMasterTrackingId = $dyn.value(_this.SelectedRowTrackingId);
                    if (masterTrackingId !== undefined && masterTrackingId !== activeMasterTrackingId) {
                        _this.syncManager.queueDependentRowAction(masterTrackingId, "navigationAction", $dyn.getFunction(_this.NavigationAction).bind(_this));
                    }
                    else {
                        $dyn.callFunction(_this.NavigationAction, _this);
                    }
                };
                _this.toggleMark = function () {
                    var activeTrackingId = $dyn.value(_this.InternalSelectedRowTrackingId);
                    var activeRowIndex = _this.getActiveRowIndex();
                    var groupMarkingInfo;
                    var isGroupHeader = _this.groupingManager.isGroupHeader(activeRowIndex);
                    if (isGroupHeader) {
                        var startIndex = _this.groupingManager.getGroupStartIndex(activeTrackingId);
                        var endIndex = _this.groupingManager.getGroupEndIndex(activeTrackingId);
                        var groupMarkingValue = _this.groupingManager.getGroupHeaderData(activeRowIndex, $dyn.reactGrid.ISMARKED_NAME);
                        var newIsMarked = (groupMarkingValue === 1 /* checked */) ? false : true;
                        groupMarkingInfo = {
                            endIndex: endIndex,
                            newIsMarked: newIsMarked,
                            startIndex: startIndex
                        };
                    }
                    if (_this.preemptiveClient) {
                        // Update value on client first
                        var isServerBound = $dyn.isServerBoundDataSource(_this.DataSource);
                        if (isGroupHeader) {
                            for (var i = groupMarkingInfo.startIndex; i <= groupMarkingInfo.endIndex; i++) {
                                _this.setRowMark(i, groupMarkingInfo.newIsMarked, isServerBound);
                            }
                        }
                        else {
                            var collectionIndex = _this.getActiveRowCollectionIndex();
                            _this.setRowMark(collectionIndex, !_this.getRowMark(collectionIndex, isServerBound), isServerBound);
                        }
                        // Re-render
                        _this.markedSelectedVersion++;
                        _this.renderReactListSync();
                    }
                    if (isGroupHeader) {
                        var startTrackingId = _this.getTrackingIdFromCollectionIndex(groupMarkingInfo.startIndex);
                        var endTrackingId = _this.getTrackingIdFromCollectionIndex(groupMarkingInfo.endIndex);
                        _this.syncManager.markGroup(startTrackingId, endTrackingId, groupMarkingInfo.newIsMarked);
                    }
                    else if ($dyn.value(_this.SelectedRowTrackingId) !== activeTrackingId) {
                        _this.syncManager.attachToggleMark(activeTrackingId, $dyn.getFunction(_this.ToggleMark).bind(_this));
                    }
                    else {
                        $dyn.applyFunction(_this.ToggleMark, _this);
                    }
                };
                _this.toggleMarkAll = function () {
                    if ($dyn.value(_this.IsMarkingEnabled)) {
                        var newValue = !$dyn.value(_this.MarkAllRecords);
                        if (_this.preemptiveClient) {
                            // Update MarkAllRecords flag
                            $dyn.setValue(_this, "MarkAllRecords", newValue);
                            // Update cached models
                            var isServerBound = $dyn.isServerBoundDataSource(_this.DataSource);
                            for (var i = 0; i < $dyn.length(_this.DataSource); i++) {
                                _this.setRowMark(i, newValue, isServerBound);
                            }
                            if (isServerBound) {
                                _this.setClientMarking(true);
                            }
                            // Re-render
                            _this.markedSelectedVersion++;
                            _this.renderReactListSync();
                        }
                        _this.syncManager.toggleMarkAll(newValue);
                    }
                };
                _this.getNextPage = function (gridProps, loadCallback) {
                    _this.dataCache.dataLoadNew(function (retValue) {
                        if (loadCallback) {
                            loadCallback();
                        }
                        if (_this.dataCache) {
                            _this.dataCache.defaultCallBack(retValue);
                        }
                    }, $dyn.ui.ScrollDirection.down);
                };
                _this.getPreviousPage = function (gridProps, loadCallback) {
                    _this.dataCache.dataLoadNew(function (retValue) {
                        if (loadCallback) {
                            loadCallback();
                        }
                        if (_this.dataCache) {
                            _this.dataCache.defaultCallBack(retValue);
                        }
                    }, $dyn.ui.ScrollDirection.up);
                };
                _this.columnResize = function (column, width) {
                    var columnInfo = _this.getColumnInfo(column);
                    // Need to re-apply ax classes (needed until we move the column header popup into the control library)
                    var $colHeader = $(_this.element).find(".dyn-headerCell[data-dyn-controlname='" + columnInfo._name + "']");
                    if ($dyn.value(columnInfo.IsFilterable)) {
                        $colHeader.addClass("isFilterable");
                    }
                    if ($dyn.value(columnInfo.SortDirection) > -1) {
                        $colHeader.addClass("sort-" + $dyn.util.enumName($dyn.value(columnInfo.SortDirection), $dyn.ui.SortDirection));
                    }
                    $dyn.callFunction(columnInfo.PersistPersonalization, columnInfo, ["width", width]);
                };
                _this.scrollStart = function () {
                    _this.isScrolling = true;
                };
                _this.scrollEnd = function () {
                    _this.isScrolling = false;
                };
                _this.columnSelected = function (column) {
                    var columnInfo = _this.getColumnInfo(column);
                    if (_this.ColumnPopups[column] && $dyn.value(_this.ColumnPopups[column].show)) {
                        _this.ColumnPopups[column].show(false);
                    }
                    else if (columnInfo && $dyn.value(columnInfo.IsFilterable) && _this.FilterManager) {
                        _this.dataCache.turnOffFastFetch();
                        _this.FilteringFields = _this.getFilteringFieldsForColumn(columnInfo);
                        _this.FilterManager.getFieldFilters(_this.FilteringFields, columnInfo.Name, $dyn.value(columnInfo.Label), _this.getFieldFilterCallBack(columnInfo, true));
                        _this.createOrShowColumnHeaderPopup(columnInfo);
                    }
                };
                _this.columnMove = function (columnToMove, columnBefore) {
                    // Select the column for moving then call MoveControl
                    var columnToMoveOptions = _this.getColumnInfo(columnToMove);
                    if (columnToMoveOptions) {
                        var columnBeforeOptions_1 = _this.getColumnInfo(columnBefore);
                        var parent_1 = _this.Name;
                        var child_1 = columnBeforeOptions_1 === null || columnBeforeOptions_1 === void 0 ? void 0 : columnBeforeOptions_1._name;
                        var formPersonalizationData_1; // Parsed JSON
                        $dyn.callFunction(columnToMoveOptions.ExecutePersonalizationCommand, columnToMoveOptions, ["SelectForMove"], function () {
                            var e_3, _a;
                            try {
                                // Get the form PersonalizationData (updated from the SelectForMove call)
                                formPersonalizationData_1 = JSON.parse($dyn.value(_this.Root.PersonalizationData));
                            }
                            catch (_b) {
                                $dyn.logNonFatalError("ReactGrid: Invalid form PersonalizationData encountered during column move");
                            }
                            if (columnBeforeOptions_1 && Array.isArray(formPersonalizationData_1)) {
                                try {
                                    // Find the parent and child that matches the columnBeforeOptions name
                                    for (var formPersonalizationData_2 = __values(formPersonalizationData_1), formPersonalizationData_2_1 = formPersonalizationData_2.next(); !formPersonalizationData_2_1.done; formPersonalizationData_2_1 = formPersonalizationData_2.next()) {
                                        var position = formPersonalizationData_2_1.value;
                                        var _c = __read(position.split(","), 2), currentParent = _c[0], currentChild = _c[1]; // Position data is in the form "<Parent>,<ChildBefore>"
                                        if (currentChild === columnBeforeOptions_1._name) {
                                            parent_1 = currentParent;
                                            child_1 = currentChild;
                                            break;
                                        }
                                    }
                                }
                                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                finally {
                                    try {
                                        if (formPersonalizationData_2_1 && !formPersonalizationData_2_1.done && (_a = formPersonalizationData_2.return)) _a.call(formPersonalizationData_2);
                                    }
                                    finally { if (e_3) throw e_3.error; }
                                }
                            }
                            var positionStr = parent_1 + ",";
                            if (child_1) {
                                positionStr += child_1;
                            }
                            _this.callingMove = true;
                            $dyn.async(function () {
                                $dyn.callFunction(columnToMoveOptions.ExecutePersonalizationCommand, columnToMoveOptions, ["MoveControl", positionStr], function () {
                                    _this.callingMove = false;
                                });
                            });
                        });
                    }
                };
                _this.toggleGroupExpandCollapse = function (rowIndex) {
                    _this.groupingManager.toggleGroupExpandCollapse(rowIndex);
                    _this.dataVersion++;
                    if (_this.getActiveRowIndex() === rowIndex) {
                        _this.markedSelectedVersion++;
                        _this.renderReactListSync();
                    }
                    else {
                        _this.changeRow(rowIndex, "groupByColumn", 4 /* none */, $dyn.ui.InputType.mouse);
                    }
                };
                _this.postRender = function () {
                    var e_4, _a;
                    if (!$dyn.value($dyn.util.controlLibraryResourcesLoaded)) {
                        return;
                    }
                    // If the grid is size to content and its size changes, then arrange its parent
                    // Needed so that the toolbar renders correctly
                    if (_this.element && _this.element.parentElement && $dyn.value(_this.LayoutWidth) === $dyn.layout.Size.content) {
                        var currentWidth = _this.element.clientWidth;
                        if (_this.previousWidth !== currentWidth) {
                            _this.previousWidth = currentWidth;
                            _this.gridInitiatedArrange = true;
                            $dyn.layout.arrange(_this.element.parentElement, true, false);
                        }
                    }
                    _this.updateFilterSortClasses();
                    if (_this.Root) {
                        if (_this.Root.controlRenderComplete) {
                            _this.Root.controlRenderComplete(_this.Name);
                        }
                        var selectedControlName_1 = $dyn.value(_this.Root.ActiveControl);
                        var selectedColumnInfo = _this.getColumnInfo(selectedControlName_1);
                        // If active control is within grid but grid doesnt have focus, then focus it
                        if (selectedColumnInfo &&
                            _this.Root.TakeFocus &&
                            _this.Root.isFormActive() &&
                            _this.Root.isInActiveFocusRegion() &&
                            _this.ControlLibGridRef &&
                            (!_this.ControlLibGridRef.hasFocus() || document.activeElement === document.body)) {
                            // if the form's active control is within the react grid than focus it
                            var timeoutValue = _this.isScrolling ? 200 : 0;
                            // if scrolling the FDT uses a debounced method of 200 ms for handling scrolling
                            window.setTimeout(function () {
                                // Need to wait for react code to finish rendering
                                if (_this.ControlLibGridRef) {
                                    $dyn.log.focus && $dyn.log.focus("React Grid: post render focus fix");
                                    var ableToFocus = _this.ControlLibGridRef.focusColumn(selectedControlName_1);
                                    if (ableToFocus) {
                                        _this.Root.updateActiveElement(document.activeElement);
                                    }
                                }
                            }, timeoutValue);
                        }
                    }
                    try {
                        for (var _b = __values(_this.postRenderCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var callback = _c.value;
                            callback();
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    _this.postRenderCallbacks = [];
                };
                _this.setRef = function (ref) {
                    _this.ControlLibGridRef = ref;
                };
                _this.onSyncCellClicked = function (event, rowIndex, props) {
                    var targetElement = _this.findSyncingColumn(event);
                    _this.syncManager.syncCellClicked(rowIndex, targetElement);
                };
                _this.onSyncCellHover = function (event, rowIndex, props) {
                    var targetElement = _this.findSyncingColumn(event);
                    _this.syncManager.syncCellHover(rowIndex, targetElement);
                };
                /**
                 * Hides the footer
                 */
                _this.hideFooter = function () {
                    _this.setFooterShown(false);
                };
                /**
                 * Calls the footerShouldShow method in control-lib to show or hide the footer
                 * @param showFooter Indicates whether or not the footer should be shown.
                 */
                _this.setFooterShown = function (showFooter) {
                    _this.ControlLibGridRef.footerShouldShow(showFooter, function () { return _this.footerVisibilityChange(showFooter); });
                };
                /**
                 * Sets whether or not the footer is shown and updates personalization and re-renders the grid.
                 * @param showFooter Indicates whether or not the footer should be shown.
                 */
                _this.footerVisibilityChange = function (showFooter) {
                    $dyn.setValue(_this, "FooterShown", showFooter);
                    // Update the grid's personalization indicating whether the footer should be shown
                    $dyn.callFunction(_this.UpdateFooterShown, _this, [$dyn.value(_this.FooterShown)]);
                };
                _this.firstRender = true;
                _this.activeColumnName = "";
                _this.calculatedAllowEdit = false;
                _this.callingMove = false;
                _this.dataVersion = 0;
                _this.defaultControlName = "";
                _this.isContainer = true;
                _this.loadingMessage = $dyn.label("Shell_LoadingTitle");
                _this.markedSelectedVersion = 0;
                _this.recalculateSize = 0;
                _this.requestingData = false;
                _this.themeVersion = 0;
                _this.isScrolling = false;
                _this.preemptiveClient = true;
                _this.createdRetreivalDialog = false;
                _this.retrievingGroupData = false;
                _this.hasFrozenChild = false;
                _this.elementInSidePanel = undefined;
                _this.rangeSelection = false;
                _this.rangePivotTrackingId = "";
                if (data && data.OverrideNoResultsMessage !== undefined && data.OverrideNoResultsMessage !== null) {
                    _this.noResultsMessage = $dyn.value(data.OverrideNoResultsMessage);
                }
                else {
                    _this.noResultsMessage = $dyn.label("List_NoResultsMessage");
                }
                _this.HeightOverride = $dyn.observable(false);
                _this.WidthOverride = $dyn.observable(false);
                _this.ColumnPopups = {};
                _this.countsExcludedControls = {};
                _this.dataSourceObservers = {};
                _this.relatedItemSubscribers = {};
                _this.FilterExpressions = {};
                _this.gridCountVersions = {};
                _this.missingFields = {};
                _this.columnInfo = [];
                _this.columnNameToInfoIndex = {};
                _this.columnObservers = [];
                _this.postRenderCallbacks = [];
                _this.modelCollectionIds = [];
                _this.telemetryEventArgs = {};
                _this.dataRetrievalProgressText = $dyn.observable("");
                _this.creatingChildren = $dyn.observable(false);
                _this.ConfirmedNoDataAbove = $dyn.observable(false);
                _this.ConfirmedNoDataBelow = $dyn.observable(false);
                _this.HasPreviousPage = $dyn.computed(function () {
                    return $dyn.value(_this.DataAbove) || (!$dyn.value(_this.ConfirmedNoDataAbove) && $dyn.length(_this.DataSource) < $dyn.value(_this.CacheSize));
                });
                _this.HasNextPage = $dyn.computed(function () {
                    return $dyn.value(_this.DataBelow) || (!$dyn.value(_this.ConfirmedNoDataBelow) && $dyn.length(_this.DataSource) < $dyn.value(_this.CacheSize));
                });
                _this.renderTimeout = $dyn.observable();
                _this.calculateChildrenTimeout = $dyn.observable();
                _this.HasRenderCallPending = $dyn.computed(function () {
                    return ($dyn.value(_this.renderTimeout) || $dyn.value(_this.calculateChildrenTimeout)) ? true : false;
                });
                if (!$dyn.isObservable(_this.FooterShown)) {
                    _this.FooterShown = $dyn.observable(_this.FooterShown);
                }
                $dyn.observe(_this.FooterShown, function () {
                    // Clear cached grid options to get new grid options as footer state has changed
                    _this.footerButton = null;
                    _this.gridOptions = null;
                    _this.renderReactListAsync();
                }, _this, undefined, true);
                $dyn.observe(_this.SelectedRowTrackingId, function () {
                    _this.markedSelectedVersion++;
                    _this.renderReactListAsync();
                }, _this, undefined, true);
                $dyn.bulkObserve(_this, function () {
                    _this.renderReactListAsync();
                }, _this.Updating, _this, undefined, GRID_PROPERTIES_TO_OBSERVE, true);
                // Computed fire if any of the dependencies change even if the computed value did not change.
                // Only want to call render if the comptued value changes
                _this.lastHasPreviousPage = $dyn.peek(_this.HasPreviousPage);
                _this.lastHasNextPage = $dyn.peek(_this.HasNextPage);
                $dyn.bulkObserve({ hasPreviousPage: _this.HasPreviousPage, hasNextPage: _this.HasNextPage }, function (changes) {
                    var callRender = false;
                    if (changes.hasPreviousPage && _this.lastHasPreviousPage !== $dyn.peek(_this.HasPreviousPage)) {
                        _this.lastHasPreviousPage = $dyn.peek(_this.HasPreviousPage);
                        callRender = true;
                    }
                    if (changes.hasNextPage && _this.lastHasNextPage !== $dyn.peek(_this.HasNextPage)) {
                        _this.lastHasNextPage = $dyn.peek(_this.HasNextPage);
                        callRender = true;
                    }
                    if (!$dyn.peek(_this.HasNextPage) && !$dyn.peek(_this.HasPreviousPage) && !_this.gridCounts.RowCount) {
                        callRender = true;
                    }
                    if (callRender) {
                        if ($dyn.peek(_this.HasPreviousPage) || $dyn.peek(_this.HasNextPage)) {
                            _this.gridCounts = {
                                ColumnCounts: _this.getEmptyColumnCounts(),
                                IsPartialCount: !!_this.IsSizeLimited(),
                                MarkedRowCount: _this.getMarkedRowCount(),
                            };
                        }
                        else {
                            _this.gridCounts = {
                                ColumnCounts: _this.getCalculatedColumnCounts(),
                                IsPartialCount: !!_this.IsSizeLimited(),
                                MarkedRowCount: _this.gridCounts && _this.gridCounts.MarkedRowCount,
                                RowCount: _this.DisplayRowCount(),
                            };
                        }
                        _this.renderReactListAsync();
                    }
                }, _this.Updating, _this, undefined, undefined, true);
                _this.dataCache = new $dyn.reactGrid.DataCache(_this.LoadDataByTrackingId, _this, _this.DataSource);
                _this.syncManager = new $dyn.reactGrid.SyncManager(_this, _this.DataSource);
                _this.groupingManager = new $dyn.reactGrid.GroupingManager(_this);
                var createChildrenChangedObserver = function () {
                    // observer for children collection changes to recalculate children
                    _this.childrenChangedComputed = $dyn.childHierarchyChanged(_this.element);
                    _this.usingDisposable($dyn.observe(_this.childrenChangedComputed, function () {
                        var rowTemplate = _this.element.dynChildren()[0];
                        if (rowTemplate.dynChildren) {
                            var defaultControl = _this._getDefaultControl(rowTemplate);
                            _this.defaultControlName = defaultControl ? defaultControl._name : "";
                            _this.calculateChildren(function () {
                                if (!_this.firstRender && !_this.callingMove) {
                                    _this.groupingManager.updateGroupHeadersAndRerender();
                                }
                            });
                        }
                    }));
                };
                _this.IsSizeLimited = $dyn.computed(function () {
                    var maxCache = _this.dataCache && _this.dataCache.MaxCacheSize;
                    return !!maxCache && $dyn.length(_this.DataSource) >= maxCache;
                });
                _this.DisplayRowCount = $dyn.computed(function () {
                    var maxCache = _this.dataCache && _this.dataCache.MaxCacheSize;
                    var rowCount = $dyn.length(_this.DataSource);
                    if (maxCache > 0 && rowCount >= maxCache) {
                        return maxCache;
                    }
                    else {
                        return rowCount;
                    }
                });
                var previouslySizeLimited = $dyn.value(_this.IsSizeLimited);
                $dyn.observe(_this.IsSizeLimited, function (target) {
                    if (!previouslySizeLimited && target) {
                        _this.requestTotals(function (canceled) {
                            $dyn.warn({
                                Label: "ReactGrid_RowLimited",
                                Message: $dyn.label("ReactGrid_RowLimited"),
                            }, _this);
                        });
                    }
                    previouslySizeLimited = target;
                    // Update the backing model collection state
                    if ($dyn.isServerBoundDataSource(_this.DataSource)) {
                        _this.DataSource.__boundDataSource.clientGridSizeLimited = target;
                    }
                });
                if (element) {
                    // May need to resize the grid if layout happens
                    _this.reflowEndWatcher = $dyn.layout.registerEndReflowHandler(element, function () {
                        if (_this.gridInitiatedArrange) {
                            _this.gridInitiatedArrange = false;
                        }
                        else {
                            _this.syncManager.reevaluateSurroundingBlockingDiv();
                            _this.recalculateSize++;
                            _this.renderReactListAsync();
                        }
                    });
                    var rowTemplate = element.dynChildren()[0];
                    if (!rowTemplate.dynChildren) {
                        $dyn.dataBind(rowTemplate, data, createChildrenChangedObserver);
                    }
                    else {
                        createChildrenChangedObserver();
                    }
                    _this.handleMouseWheel = function (evt) {
                        if (_this.element && _this.element.querySelector(".ScrollbarLayout_mainVertical")) {
                            evt.preventDefault();
                        }
                    };
                    element.addEventListener("mousewheel", _this.handleMouseWheel);
                }
                if (_this.DataSource) {
                    if ($dyn.isObservable(_this.DataSource)) {
                        var dataSourceObserver = $dyn.observe(_this.DataSource, function () {
                            _this.dataVersion++;
                            _this.renderReactListAsync();
                        }, _this, undefined, true);
                        if ($dyn.isServerBoundDataSource(_this.DataSource)) {
                            _this.dataSourceObservers[_this.DataSource.__dataSourceName] = dataSourceObserver;
                        }
                    }
                    if ($dyn.isServerBoundDataSource(_this.DataSource)) {
                        _this.modelCollectionIds.push(_this.DataSource.__boundDataSource.id);
                        if (_this.DataSource.__boundDataSource.markedCount) {
                            _this.usingDisposable($dyn.observe(_this.DataSource.__boundDataSource.markedCount, function (value) {
                                _this.gridCounts = {
                                    ColumnCounts: _this.gridCounts && _this.gridCounts.ColumnCounts && $dyn.util.objectAssign({}, _this.gridCounts.ColumnCounts),
                                    IsPartialCount: _this.gridCounts && _this.gridCounts.IsPartialCount,
                                    MarkedRowCount: value,
                                    RowCount: _this.gridCounts && _this.gridCounts.RowCount,
                                };
                                _this.markedSelectedVersion++;
                                _this.renderReactListAsync();
                            }, _this, undefined, true));
                        }
                        if (_this.DataSource.__boundDataSource.onClear) {
                            _this.clearSubscription = _this.DataSource.__boundDataSource.onClear.subscribe(function () { _this.onCacheClear(); });
                        }
                    }
                }
                _this.themeChangedHandler = function () {
                    _this.themeVersion++;
                    // clear out cached value so this style is recalculated
                    _this.insideListPanelStyle = undefined;
                    _this.renderReactListAsync();
                };
                if ($dyn.ax.formPersonalizationPane && $dyn.isObservable($dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode)) {
                    _this.usingDisposable($dyn.observe($dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode, function (mode) {
                        if (_this.personalizationMode !== mode) {
                            _this.personalizationMode = mode;
                            if (!_this.firstRender && $dyn.value(_this.AllowPersonalization)) {
                                _this.postRenderCallbacks.push(function () {
                                    $dyn.ax.personalizationUtil && $dyn.ax.personalizationUtil.forceUpdateFormPersonalizationData();
                                });
                                _this.renderReactListAsync();
                            }
                        }
                    }));
                }
                $(document).on("themechanged", _this.themeChangedHandler);
                if (_this.Root && $dyn.isObservable(_this.Root.IsInViewMode)) {
                    // Need to recreate the columns to no longer have edit pencil
                    _this.usingDisposable($dyn.observe(_this.Root.IsInViewMode, function () {
                        _this.columnChanged();
                    }, _this, undefined, true));
                }
                if ($dyn.peek(_this.HasPreviousPage) || $dyn.peek(_this.HasNextPage)) {
                    _this.gridCounts = {
                        ColumnCounts: _this.getEmptyColumnCounts(),
                        IsPartialCount: !!_this.IsSizeLimited(),
                        MarkedRowCount: _this.getMarkedRowCount(),
                    };
                }
                else {
                    _this.gridCounts = {
                        ColumnCounts: _this.getCalculatedColumnCounts(),
                        IsPartialCount: !!_this.IsSizeLimited(),
                        MarkedRowCount: _this.getMarkedRowCount(),
                        RowCount: _this.DisplayRowCount(),
                    };
                }
                // Render once to start
                _this.groupingManager.updateGroupHeadersAndRerender();
                return _this;
            }
            ReactList.freezingEnabled = function () {
                return $dyn.util.isFlightEnabled(FREEZING_FEATURE_NAME);
            };
            ReactList.valueCalculator = function (control, dataSource) {
                var count = dataSource.totals && dataSource.totals[control.FieldName];
                if (count) {
                    var bigNumOptions = $dyn.util.createBigNumOptions(control);
                    count.configure(bigNumOptions);
                    return count.GetValue();
                }
            };
            ReactList.emptyValueCalculator = function () {
                return null;
            };
            ReactList.prototype.getAllowEditPropValue = function () {
                return $dyn.value(this.AllowEdit) || this.calculatedAllowEdit;
            };
            ReactList.prototype.updateConfirmations = function (direction, noInserts) {
                if (direction === $dyn.ui.ScrollDirection.down) {
                    this.ConfirmedNoDataBelow(noInserts);
                }
                else if (direction === $dyn.ui.ScrollDirection.up) {
                    this.ConfirmedNoDataAbove(noInserts);
                }
            };
            ReactList.prototype.MayHaveMoreData = function (direction) {
                if (!$dyn.value(this.DataAbove) && !$dyn.value(this.DataBelow) && $dyn.length(this.DataSource) === $dyn.value(this.CacheSize)) {
                    return false;
                }
                if ($dyn.value(this.IsSizeLimited)) {
                    return false;
                }
                if (direction === $dyn.ui.ScrollDirection.down) {
                    return $dyn.value(this.HasNextPage);
                }
                else if (direction === $dyn.ui.ScrollDirection.up) {
                    return $dyn.value(this.HasPreviousPage);
                }
            };
            ReactList.prototype.AreControlsCrossBoundary = function (activeControl, lastActive) {
                return $dyn.peek(activeControl.ServiceBoundary) !== $dyn.peek(lastActive.ServiceBoundary);
            };
            // Return false if Grid handled the focus, true otherwise
            ReactList.prototype.tryFocus = function (controlElement) {
                var controlName = controlElement ? controlElement.getAttribute("data-dyn-controlname") : "";
                if (controlName === this.activeColumnName && this.ControlLibGridRef && this.ControlLibGridRef.hasFocus()) {
                    return false;
                }
                return true;
            };
            // if AX finds the react grid control using $dyn.ui.getLiveControl, have the grid figure out the correct child control
            ReactList.prototype.getLiveControl = function (element) {
                var e_5, _a;
                var _this = this;
                var liveControl = this;
                var testElement = element;
                var isHeader = false;
                var isGrid = false;
                var isCardChildElement = false;
                var cellElement = null;
                var isListGrid = ($dyn.value(this.Mode) === $dyn.ui.ListMode.list);
                while (testElement && testElement.classList) {
                    if (testElement.classList.contains("dyn-activeRowCell") || testElement.classList.contains("dyn-inactiveRowCell")) {
                        cellElement = testElement;
                        break;
                    }
                    else if (testElement.classList.contains("dyn-headerCell")) {
                        cellElement = testElement;
                        isHeader = true;
                        break;
                    }
                    else if (testElement.classList.contains("dyn-grid") || testElement.classList.contains("dyn-listGrid")) {
                        isGrid = true;
                        break;
                    }
                    else if (isListGrid && testElement.hasAttribute("data-dyn-controlname") && !testElement.classList.contains("dyn-listGrid")) {
                        cellElement = testElement;
                        isCardChildElement = true;
                        break;
                    }
                    else {
                        testElement = testElement.parentElement;
                    }
                }
                if (!isGrid && cellElement) {
                    var columnName = "";
                    if (isHeader || isCardChildElement) {
                        columnName = cellElement.getAttribute("data-dyn-controlname");
                    }
                    else {
                        cellElement = $(cellElement).find(".public_fixedDataTableCell_cellContent >")[0];
                        if (cellElement) {
                            columnName = cellElement.getAttribute("data-dyn-controlname");
                        }
                    }
                    var columnOptions = this.getColumnInfo(columnName);
                    if (columnOptions) {
                        if (columnOptions._typeName === "ReferenceGroup") {
                            var childName = $(element).closest("[data-dyn-controlname]").attr("data-dyn-controlname");
                            var refGroupElement = columnOptions._element || columnOptions.element; // Depending on if serverform bound the control
                            if (refGroupElement && refGroupElement.dynChildren) {
                                var refDynChildren = refGroupElement.dynChildren();
                                try {
                                    for (var refDynChildren_1 = __values(refDynChildren), refDynChildren_1_1 = refDynChildren_1.next(); !refDynChildren_1_1.done; refDynChildren_1_1 = refDynChildren_1.next()) {
                                        var refDynChild = refDynChildren_1_1.value;
                                        var refGroupChildInfo = $dyn.controlOptions(refDynChild);
                                        if (refGroupChildInfo._name === childName) {
                                            refGroupChildInfo.ReferenceGroup = columnOptions;
                                            columnOptions = refGroupChildInfo;
                                        }
                                    }
                                }
                                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                                finally {
                                    try {
                                        if (refDynChildren_1_1 && !refDynChildren_1_1.done && (_a = refDynChildren_1.return)) _a.call(refDynChildren_1);
                                    }
                                    finally { if (e_5) throw e_5.error; }
                                }
                            }
                        }
                        if (columnOptions.Name === undefined && columnOptions._name) {
                            columnOptions.Name = columnOptions._name;
                        }
                        columnOptions.listControl = this;
                        columnOptions.Root = this.Root;
                        columnOptions.isInGrid = function () { return true; };
                        columnOptions.convertMasterTrackingId = true;
                        columnOptions.focusCallback = function () {
                            var _this = this;
                            $dyn.log.focus && $dyn.log.focus("React Grid: column focus callback");
                            if (this.listControl) {
                                var name_1 = this.Name;
                                if (this.ReferenceGroup) {
                                    name_1 = this.ReferenceGroup.Name;
                                }
                                var focusColumnCallback = function () {
                                    if (_this.listControl && _this.listControl.ControlLibGridRef) {
                                        _this.listControl.ControlLibGridRef.focusColumn(name_1);
                                    }
                                };
                                this.listControl.scrollColumnIntoViewIfNeeded(name_1, focusColumnCallback);
                            }
                            $dyn.focusCompleted(true);
                        }.bind(columnOptions);
                        var columnOptionsCopy = {};
                        $dyn.util.objectAssign(columnOptionsCopy, columnOptions, {
                            element: cellElement,
                            serverIndex: this.previewTrackingId,
                            Value: this.previewValue,
                        });
                        if (this.previewControlIsValid !== undefined) {
                            // preview code is expecting a function
                            columnOptionsCopy.controlIsValid = function () { return _this.previewControlIsValid; };
                        }
                        if ($dyn.length(this.DataSource) > 0) {
                            if (isHeader) {
                                var activeCollectionIndex = this.getActiveRowCollectionIndex();
                                if (activeCollectionIndex !== -1) {
                                    columnOptionsCopy.DataSource = $dyn.value(this.DataSource)[activeCollectionIndex];
                                }
                            }
                            else {
                                var $row = $(element).closest("[aria-rowindex]");
                                var rowIndex = parseInt($row.attr("aria-rowindex"), 10);
                                if (!isNaN(rowIndex)) {
                                    // aria-rowindex is one-based
                                    rowIndex--;
                                    if ($dyn.value(this.IsHeaderVisible)) {
                                        // aria-rowindex includes the header row as the first row
                                        rowIndex--;
                                    }
                                    var collectionIndex = this.groupingManager.rowIndexToCollectionIndex(rowIndex);
                                    if (collectionIndex !== -1) {
                                        columnOptionsCopy.DataSource = $dyn.value(this.DataSource)[collectionIndex];
                                    }
                                }
                            }
                        }
                        liveControl = columnOptionsCopy;
                    }
                }
                return liveControl;
            };
            ReactList.prototype.getColumnInfo = function (columnName) {
                var columnInfoIndex = this.columnNameToInfoIndex[columnName];
                if (columnInfoIndex !== undefined) {
                    return this.columnInfo[columnInfoIndex];
                }
            };
            ReactList.prototype.scrollActiveRowIntoView = function () {
                this.ControlLibGridRef && this.ControlLibGridRef.scrollActiveRowIntoView && this.ControlLibGridRef.scrollActiveRowIntoView();
            };
            ReactList.prototype.scrollColumnIntoViewIfNeeded = function (column, callback) {
                // List grids are single column so dont have scrollColumnIntoViewIfNeeded implemented
                if (this.ControlLibGridRef && this.ControlLibGridRef.scrollColumnIntoViewIfNeeded) {
                    this.ControlLibGridRef.scrollColumnIntoViewIfNeeded(column, callback);
                }
                else if (callback !== undefined) {
                    callback();
                }
            };
            ReactList.prototype.setChildControlFocus = function () {
                if (this.ControlLibGridRef) {
                    this.ControlLibGridRef.focusActiveCell();
                    return true;
                }
                return false;
            };
            ReactList.prototype.goToActiveRow = function () {
                var serverRowIndex = this.getRowIndexFromTrackingId($dyn.value(this.SelectedRowTrackingId));
                if (serverRowIndex === this.getActiveRowIndex()) {
                    this.setChildControlFocus();
                }
                else if (serverRowIndex >= 0) {
                    this.changeRow(serverRowIndex, this.activeColumnName, 0 /* select */, $dyn.ui.InputType.keyboard);
                }
            };
            /**
             * Needed because method exists on legacy grid and is called from serverform
             */
            ReactList.prototype.recalculateRowIndex = function (rowIndex) {
                return rowIndex;
            };
            /*
             * Retrieve the collection index of the active row to determine correct stying when grouping
             */
            ReactList.prototype.getCollectionIndexFromActiveRowTrackingId = function () {
                if ($dyn.isServerBoundDataSource(this.DataSource)) {
                    return this.getCollectionIndexFromTrackingId($dyn.value(this.ActiveRowTrackingId));
                }
                return -1;
            };
            ReactList.prototype.getActiveRowIndex = function () {
                return this.getRowIndexFromTrackingId($dyn.value(this.InternalSelectedRowTrackingId));
            };
            ReactList.prototype.getActiveRowCollectionIndex = function () {
                return this.groupingManager.rowIndexToCollectionIndex(this.getActiveRowIndex());
            };
            ReactList.prototype.getRowIndexFromTrackingId = function (trackingId) {
                if (trackingId) {
                    return this.groupingManager.getRowIndexFromTrackingId(trackingId);
                }
                return -1;
            };
            ReactList.prototype.getCollectionIndexFromTrackingId = function (trackingId) {
                if ($dyn.serverForm && $dyn.serverForm.ModelManager && $dyn.isServerBoundDataSource(this.DataSource)) {
                    var modelId = this.DataSource.__boundDataSource.name + "_" + trackingId;
                    var formId = this.Root && this.Root.Id;
                    var activeModel = $dyn.serverForm.ModelManager.getModel(modelId, formId);
                    return activeModel ? activeModel.collectionIndex : -1;
                }
                else if (trackingId) {
                    return parseInt(trackingId, 10);
                }
                else {
                    return -1;
                }
            };
            ReactList.prototype.getTrackingIdFromRowIndex = function (rowIndex) {
                return this.groupingManager.getTrackingIdFromRowIndex(rowIndex);
            };
            ReactList.prototype.getTrackingIdFromCollectionIndex = function (collectionIndex) {
                if (collectionIndex < 0 || collectionIndex >= $dyn.length(this.DataSource)) {
                    // This is an error case, where we got an invalid collection index (most likely -1)
                    return "";
                }
                if ($dyn.isServerBoundDataSource(this.DataSource)) {
                    return $dyn.value(this.DataSource)[collectionIndex].masterTrackingId;
                }
                return collectionIndex.toString();
            };
            /**
             * @remarks Only used by PCF
             * @internal
             */
            ReactList.prototype.getActiveRowClientIndex = function () {
                return this.getActiveRowIndex();
            };
            /**
             * @remarks Only used by PCF
             * @internal
             */
            ReactList.prototype._getValues = function () {
                var rows = $(".fixedDataTableLayout_rowsContainer", this.element).find(".public_fixedDataTable_bodyRow");
                var rowsArray = [];
                rows.each(function (index, element) {
                    var $row = $(element);
                    var rowArray = [];
                    $row.find("[data-dyn-controlname]").each(function (listCellIndex, listCell) {
                        var value = "";
                        if ($(listCell).is(".dyn-checkbox")) {
                            value = $(listCell).find("[role='checkbox']").attr("aria-checked");
                            // Need to convert to expected format in PCF framework
                            value = value === "true" ? "True" : "False";
                        }
                        else {
                            var foundInputs = $(listCell).find("input");
                            if (foundInputs.length > 0) {
                                // Simple taking the first input element won't cover all cases, but it is acceptable
                                // given the purposes of this method.
                                var inputElement = foundInputs[0];
                                value = inputElement.value;
                            }
                        }
                        rowArray.push(value);
                    });
                    rowsArray.push(rowArray);
                });
                return rowsArray;
            };
            ReactList.prototype.renderReactListAsync = function () {
                var _this = this;
                if (this.renderTimeout()) {
                    this.renderTimeout().cancel();
                }
                else if (this.requestingData) {
                    return;
                }
                if (this.Root && this.Root.controlRenderPending) {
                    this.Root.controlRenderPending(this.Name);
                }
                // Try to batch multiple calls to render
                this.renderTimeout($dyn.async(function () {
                    if (_this.ForceInvisibleRender || (_this.element && _this.element.offsetParent !== null) || _this.IsInsidePreviewForm()) {
                        _this.renderReactList();
                    }
                    else {
                        $dyn.log.reactList && $dyn.log.reactList("ReactList: Prevent invisible render");
                        if (_this.Root && _this.Root.controlRenderComplete) {
                            _this.Root.controlRenderComplete(_this.Name);
                        }
                    }
                    _this.renderTimeout(null);
                }, 0, "Render ReactList"));
            };
            ReactList.prototype.renderReactListSync = function () {
                if (this.renderTimeout()) {
                    this.renderTimeout().cancel();
                    this.renderTimeout(null);
                }
                if (this.Root && this.Root.controlRenderPending) {
                    this.Root.controlRenderPending(this.Name);
                }
                this.renderReactList();
            };
            /**
             * Gets common context menu options for list
             * @returns An array of Objects, each representing an option in the context menu.
             */
            ReactList.prototype.getCommonGridContextMenuOptions = function () {
                var options = [];
                if (this.ExportToExcel && $dyn.value(this.ExportAllowed)) {
                    var exportOption = {
                        Command: this.ExecuteExportToExcel.bind(this, false),
                        Label: $dyn.label("ContextMenu_ExportAllRows"),
                    };
                    options.push(exportOption);
                    if (this.getMarkedRowCount() > 0) {
                        exportOption = {
                            Command: this.ExecuteExportToExcel.bind(this, true),
                            Label: $dyn.label("ContextMenu_ExportMarkedRows"),
                        };
                        options.push(exportOption);
                    }
                }
                if ($dyn.value(this.AllowPersonalization) && this.Root && $dyn.value(this.Root.AllowExplicitPersonalization) && !this.Root.isPopup()) {
                    var addColumnOption = { Label: $dyn.label("ContextMenu_AddColumns"), Command: this.addColumns, Enabled: true };
                    options.push(addColumnOption);
                }
                return options;
            };
            /**
             * Gets context menu options for list
             * @returns An array of Objects, each representing an option in the context menu.
             */
            ReactList.prototype.getContextMenuOptions = function () {
                var options = this.getCommonGridContextMenuOptions();
                Array.prototype.push.apply(options, _super.prototype.getContextMenuOptions.call(this));
                return options;
            };
            /**
             * Requests grid totals via the control library unless all data is already retrieved.
             * @param complete The void, no-arg callback executed upon completion of count calculations.
             */
            ReactList.prototype.requestTotalsFromControlLibrary = function (complete) {
                var _this = this;
                if (this.MayHaveMoreDataAboveOrBelow()) {
                    this.ControlLibGridRef.requestTotals(function (canceled) {
                        complete && complete(canceled);
                        _this.renderReactListAsync();
                    });
                }
                else {
                    complete && complete(false);
                }
            };
            /**
             * Sorts the provided column by the provided direction (clearing other sorts)
             * @param columnInfo The column to be sorted
             * @param direction The sort direction using $dyn.ui.SortDirection
             * @param clearSorts Whether or not to clear the existing sort
             * @param callback Callback function for after the sort is finished
             */
            ReactList.prototype.sort = function (columnInfo, direction, clearSorts, callback) {
                var _this = this;
                var sortDirection = "1"; // ascending
                if (direction === $dyn.ui.SortDirection.descending) {
                    sortDirection = "0"; // SetSorts uses 1 for ascending 0 for descending
                }
                var clearSortsAsStr = clearSorts ? "1" : "0";
                var cachedExpressionObservable = this.FilterExpressions[columnInfo.Name];
                if (cachedExpressionObservable && cachedExpressionObservable.__source) {
                    this.FilterManager.setFieldSorts([cachedExpressionObservable.__source, sortDirection, clearSortsAsStr], null, callback);
                }
                else {
                    if (!this.FilterExpressions[columnInfo._name]) {
                        this.FilterExpressions[columnInfo._name] = $dyn.observable();
                    }
                    this.FilteringFields = this.getFilteringFieldsForColumn(columnInfo);
                    this.FilterManager.getFieldFilters(this.FilteringFields, columnInfo.Name, $dyn.value(columnInfo.Label), function (fieldFilters) {
                        _this.getFieldFilterCallBack(columnInfo, false)(fieldFilters);
                        $dyn.async(function () {
                            _this.FilterManager.setFieldSorts([fieldFilters, sortDirection, clearSortsAsStr], null, callback);
                        });
                    });
                }
            };
            ReactList.prototype.removeSort = function (removedGrouping) {
                var e_6, _a;
                var _this = this;
                if (!removedGrouping) {
                    return;
                }
                var _loop_1 = function (columnGrouping) {
                    var cachedExpressionObservable = this_1.FilterExpressions[columnGrouping.ControlName];
                    if (cachedExpressionObservable && cachedExpressionObservable.__source) {
                        this_1.FilterManager.removeFieldSorts(cachedExpressionObservable.__source);
                    }
                    else {
                        if (!this_1.FilterExpressions[columnGrouping.ControlName]) {
                            this_1.FilterExpressions[columnGrouping.ControlName] = $dyn.observable();
                        }
                        var columnInfo_1 = this_1.getColumnInfo(columnGrouping.ControlName);
                        this_1.FilteringFields = this_1.getFilteringFieldsForColumn(columnInfo_1);
                        this_1.FilterManager.getFieldFilters(this_1.FilteringFields, columnInfo_1.Name, $dyn.value(columnInfo_1.Label), function (fieldFilters) {
                            _this.getFieldFilterCallBack(columnInfo_1, false)(fieldFilters);
                            $dyn.async(function () {
                                _this.FilterManager.removeFieldSorts(fieldFilters);
                            });
                        });
                    }
                };
                var this_1 = this;
                try {
                    for (var removedGrouping_1 = __values(removedGrouping), removedGrouping_1_1 = removedGrouping_1.next(); !removedGrouping_1_1.done; removedGrouping_1_1 = removedGrouping_1.next()) {
                        var columnGrouping = removedGrouping_1_1.value;
                        _loop_1(columnGrouping);
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (removedGrouping_1_1 && !removedGrouping_1_1.done && (_a = removedGrouping_1.return)) _a.call(removedGrouping_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            };
            ReactList.prototype.deleteClientRow = function (trackingId) {
                if ($dyn.serverForm && $dyn.isServerBoundDataSource(this.DataSource)) {
                    var formId_2 = this.Root && this.Root.Id;
                    this.modelCollectionIds.forEach(function (collectionId) {
                        var collection = $dyn.serverForm.ModelManager.getModelCollection(collectionId, formId_2);
                        var modelId = collection.name + "_" + trackingId;
                        var model = $dyn.serverForm.ModelManager.getModel(modelId);
                        if (model) {
                            model.isSelected = false;
                            model.isMarked = false;
                            // Totals don't need to be updated because they are only updated when model gets updated
                            // and for client created models they would not have those fields set
                            var index = model.collectionIndex;
                            if ($dyn.isObservableArray(collection.items)) {
                                collection.items.splice(index, 1);
                            }
                            collection.numberOfClientRows--;
                            for (var i = index; i < $dyn.length(collection.items); i++) {
                                $dyn.value(collection.items)[i].collectionIndex = i;
                            }
                            $dyn.serverForm.ModelManager.deleteModel(modelId, formId_2);
                        }
                    });
                }
                else {
                    var collectionIndex = this.getCollectionIndexFromTrackingId(trackingId);
                    $dyn.value(this.DataSource).splice(collectionIndex, 1);
                }
            };
            ReactList.prototype.setClientMarking = function (value) {
                if ($dyn.serverForm && $dyn.isServerBoundDataSource(this.DataSource)) {
                    var formId_3 = this.Root && this.Root.Id;
                    this.modelCollectionIds.forEach(function (collectionId) {
                        var collection = $dyn.serverForm.ModelManager.getModelCollection(collectionId, formId_3);
                        if (collection) {
                            collection.clientMarking = value;
                        }
                    });
                }
            };
            ReactList.prototype.getColumnMessages = function (rowIndex) {
                var e_7, _a;
                var rowMessages = [];
                try {
                    for (var _b = __values(this.columnInfo), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var column = _c.value;
                        var columnValidity = this.getRowData(rowIndex, "_VIRTUALIZED_" + column.Name + "_Validity");
                        if (columnValidity && $dyn.length(columnValidity.messages) > 0) {
                            rowMessages = rowMessages.concat(columnValidity.messages);
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
                return rowMessages;
            };
            ReactList.prototype.dispose = function () {
                var e_8, _a;
                if (this.renderTimeout()) {
                    this.renderTimeout().cancel();
                    this.renderTimeout(null);
                }
                if (this.calculateChildrenTimeout()) {
                    this.calculateChildrenTimeout().cancel();
                    this.calculateChildrenTimeout(null);
                }
                if (this.element) {
                    ReactDOM && ReactDOM.unmountComponentAtNode(this.element.querySelector(".reactGrid"));
                    this.element.removeEventListener("mousewheel", this.handleMouseWheel);
                }
                if (this.reflowEndWatcher) {
                    this.reflowEndWatcher.dispose();
                    this.reflowEndWatcher = null;
                }
                if (this.clearSubscription && $dyn.isServerBoundDataSource(this.DataSource)) {
                    this.DataSource.__boundDataSource.onClear.unsubscribe(this.clearSubscription);
                    this.clearSubscription = undefined;
                }
                if (this.cacheClearAsync) {
                    this.cacheClearAsync.cancel();
                    this.cacheClearAsync = null;
                }
                // Clear dependencies on computeds that used the DataSource to be safe
                if (this.HasPreviousPage && this.HasPreviousPage.valueChanged) {
                    this.HasPreviousPage.valueChanged.clearAllDependencies();
                }
                if (this.HasNextPage && this.HasNextPage.valueChanged) {
                    this.HasNextPage.valueChanged.clearAllDependencies();
                }
                if (this.IsSizeLimited && this.IsSizeLimited.valueChanged) {
                    this.IsSizeLimited.valueChanged.clearAllDependencies();
                }
                if (this.DisplayRowCount && this.DisplayRowCount.valueChanged) {
                    this.DisplayRowCount.valueChanged.clearAllDependencies();
                }
                try {
                    for (var _b = __values(this.columnObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var columnObserver = _c.value;
                        columnObserver.dispose();
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
                this.columnObservers = null;
                for (var columnName in this.ColumnPopups) {
                    if (this.ColumnPopups.hasOwnProperty(columnName)) {
                        $dyn.unbind(this.ColumnPopups[columnName].$popupElement[0]);
                        this.ColumnPopups[columnName].$popupElement.remove();
                    }
                }
                this.ColumnPopups = null;
                for (var dataSourceName in this.dataSourceObservers) {
                    if (this.dataSourceObservers.hasOwnProperty(dataSourceName)) {
                        this.dataSourceObservers[dataSourceName].dispose();
                    }
                }
                this.dataSourceObservers = null;
                var rootId = this.Root && this.Root.Id;
                if ($dyn.serverForm && rootId) {
                    for (var relatedId in this.relatedItemSubscribers) {
                        if (this.relatedItemSubscribers.hasOwnProperty(relatedId)) {
                            var relatedCollection = $dyn.serverForm.ModelManager.getModelCollection(relatedId, rootId);
                            if (relatedCollection) {
                                relatedCollection.itemsChanged().unsubscribe(this.relatedItemSubscribers[relatedId]);
                            }
                        }
                    }
                    this.relatedItemSubscribers = null;
                }
                this.dataCache && this.dataCache.dispose();
                this.dataCache = null;
                this.syncManager && this.syncManager.dispose();
                this.syncManager = null;
                this.groupingManager && this.groupingManager.dispose();
                this.groupingManager = null;
                $(document).off("themechanged", this.themeChangedHandler);
                this.childrenChangedComputed && this.childrenChangedComputed.valueChanged.clearAllDependencies();
                this.columnInfo = [];
                _super.prototype.dispose.call(this);
            };
            ReactList.prototype.MayHaveMoreDataAboveOrBelow = function () {
                return this.MayHaveMoreData($dyn.ui.ScrollDirection.down) || this.MayHaveMoreData($dyn.ui.ScrollDirection.up);
            };
            ReactList.prototype.getCollectionData = function (collectionIndex, columnKey, dataSourceName) {
                var model = $dyn.value(this.DataSource)[collectionIndex];
                if (model) {
                    if ($dyn.serverForm && $dyn.serverForm.isModel(model)) {
                        // Give precedence to internal client values
                        var pendingValue = "_INTERNAL_" + columnKey;
                        if (dataSourceName && model.collectionName !== dataSourceName) {
                            var related = model.getRelated && model.getRelated(dataSourceName, collectionIndex);
                            if (related && related.doesPropertyExist) {
                                if (related.doesPropertyExist(pendingValue)) {
                                    return related.getValue(pendingValue);
                                }
                                else if (related.doesPropertyExist(columnKey)) {
                                    return related.getValue(columnKey);
                                }
                            }
                        }
                        else if (model.doesPropertyExist) {
                            if (model.doesPropertyExist(pendingValue)) {
                                return model.getValue(pendingValue);
                            }
                            else if (model.doesPropertyExist(columnKey)) {
                                return model.getValue(columnKey);
                            }
                        }
                    }
                    else {
                        return model[columnKey];
                    }
                }
            };
            ReactList.prototype.getFilteringFieldsForColumn = function (columnInfo) {
                var e_9, _a;
                var filteringFields = [];
                if (columnInfo.TypeName === "ReferenceGroup") {
                    var refGroupElement = columnInfo._element || columnInfo.element;
                    if (refGroupElement && refGroupElement.dynChildren) {
                        var refDynChildren = refGroupElement.dynChildren();
                        if (refDynChildren) {
                            try {
                                for (var refDynChildren_2 = __values(refDynChildren), refDynChildren_2_1 = refDynChildren_2.next(); !refDynChildren_2_1.done; refDynChildren_2_1 = refDynChildren_2.next()) {
                                    var refGroupChildElement = refDynChildren_2_1.value;
                                    var refGroupChildInfo = $dyn.controlOptions(refGroupChildElement);
                                    if (refGroupChildInfo) {
                                        filteringFields.push({
                                            FieldName: refGroupChildInfo.FieldName,
                                            FormDataSourceName: refGroupChildInfo.DataSourceName,
                                            Label: $dyn.value(refGroupChildInfo.Label)
                                        });
                                    }
                                }
                            }
                            catch (e_9_1) { e_9 = { error: e_9_1 }; }
                            finally {
                                try {
                                    if (refDynChildren_2_1 && !refDynChildren_2_1.done && (_a = refDynChildren_2.return)) _a.call(refDynChildren_2);
                                }
                                finally { if (e_9) throw e_9.error; }
                            }
                        }
                    }
                }
                else if (columnInfo.TypeName === "SegmentedEntry") {
                    // Segmented entry display value is stored in a reference table linked through the field's EDT
                    // eg. Table.LedgerDimension (int64 RecId) -> DimensionAttributeValueCombination.DisplayValue (str)
                    filteringFields = [{
                            FieldName: $dyn.value(columnInfo.ReferenceValueDataSourceFieldName),
                            FormDataSourceName: $dyn.value(columnInfo.ReferenceValueDataSourceName),
                            Label: $dyn.value(columnInfo.Label)
                        }];
                }
                else {
                    filteringFields = [{ FieldName: columnInfo.FieldName, FormDataSourceName: columnInfo.DataSourceName, Label: $dyn.value(columnInfo.Label) }];
                }
                return filteringFields;
            };
            /**
             * If the grid has all its data, returns the columns that allow totals and have totals shown
             * @param columnInfo The columnInfo to get columns with totals from
             * @returns An array of the columns that allow totals and have totals shown
             */
            ReactList.prototype.getColumnsWithTotals = function () {
                return this.columnInfo.filter(function (column) {
                    return $dyn.value(column.AllowTotal) && $dyn.value(column.TotalShown);
                });
            };
            ReactList.prototype.getColumnsOptions = function () {
                if (this.element && this.element.dynChildren && $dyn.length(this.element.dynChildren) > 0) {
                    var row = this.element.dynChildren()[0];
                    if (row) {
                        var columns = row.dynChildren();
                        if (columns) {
                            var columnsOptions_1 = [];
                            var getOptions_1 = function (controlElement) {
                                var controlOptions = $dyn.controlOptions(controlElement);
                                if (controlOptions.TypeName === "Group") {
                                    var groupChildren = controlElement.dynChildren();
                                    groupChildren.forEach(function (childElement) {
                                        getOptions_1(childElement);
                                    });
                                }
                                else {
                                    columnsOptions_1.push(controlOptions);
                                }
                            };
                            columns.forEach(function (c) {
                                getOptions_1(c);
                            });
                            return columnsOptions_1;
                        }
                    }
                }
            };
            ReactList.prototype.resetGroupingGridOptions = function () {
                this.groupHeaderLabelButton = null;
                this.ungroupAllButton = null;
                this.gridOptions = null;
            };
            ReactList.prototype.hasDirtyDataSource = function () {
                var e_10, _a;
                var retVal = false;
                if ($dyn.serverForm && $dyn.isServerBoundDataSource(this.DataSource)) {
                    var formId = this.Root && this.Root.Id;
                    try {
                        for (var _b = __values(this.modelCollectionIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var collectionId = _c.value;
                            var collection = $dyn.serverForm.ModelManager.getModelCollection(collectionId, formId);
                            if (collection && collection.IsDirty) {
                                retVal = true;
                                break;
                            }
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                }
                return retVal;
            };
            ReactList.prototype.applyVirtualizedPropertyFirstTime = function () {
                if (!$dyn.value(this.creatingChildren)) {
                    this.calculateChildrenAndRenderAsync();
                }
            };
            /**
             * Sync the InternalSelectedTrackingId with the SelectedRowTrackingId
             */
            ReactList.prototype.resetInternalSelectedTrackingId = function () {
                if ($dyn.isServerBoundDataSource(this.DataSource)) {
                    // only reset if client marking is false
                    if (!this.DataSource.__boundDataSource.clientMarking) {
                        this.DataSource.__boundDataSource.internalActiveMasterTrackingId($dyn.value(this.SelectedRowTrackingId));
                    }
                }
                else {
                    $dyn.setValue(this, "InternalSelectedRowTrackingId", $dyn.value(this.SelectedRowTrackingId));
                }
            };
            ReactList.prototype.onCacheClear = function () {
                var _this = this;
                if (this.ControlLibGridRef) {
                    this.ControlLibGridRef.recalculateScrollTop();
                }
                if (this.syncManager) {
                    this.syncManager.onCacheClear();
                }
                this.ConfirmedNoDataBelow(false);
                this.ConfirmedNoDataAbove(false);
                this.gridCounts = {
                    ColumnCounts: this.getEmptyColumnCounts(),
                    IsPartialCount: false,
                    MarkedRowCount: this.getMarkedRowCount(),
                };
                this.clearRangeSelection();
                // Need to have the view interactions completed first in case a sort direction changed
                this.cacheClearAsync = $dyn.async(function () {
                    var willCauseRerender = _this.groupingManager.onCacheClear();
                    if (!willCauseRerender) {
                        _this.renderReactListAsync();
                    }
                });
            };
            /**
             * further request all data for specific group
             * @param complete The void, no-arg callback executed upon completion of data retrieval
             */
            ReactList.prototype.furtherRequestGroupTotals = function (totallingGroupTrackingId, complete) {
                var _this = this;
                var pageRetrieved = function () {
                    if (_this.retrievingGroupData) {
                        $dyn.setValue(_this, "dataRetrievalProgressText", $dyn.format($dyn.label("Grid_RowProcessed"), $dyn.length(_this.DataSource)));
                        window.setTimeout(function () { _this.furtherRequestGroupTotals(totallingGroupTrackingId, complete); });
                    }
                };
                // Need more data or not
                if (this.retrievingGroupData) {
                    if (this.groupingManager.isFirstGroup(totallingGroupTrackingId)) {
                        window.setTimeout(function () { _this.getPreviousPage(null, pageRetrieved); });
                    }
                    else if (this.groupingManager.isLastGroup(totallingGroupTrackingId)) {
                        window.setTimeout(function () { _this.getNextPage(null, pageRetrieved); });
                    }
                    else {
                        complete && complete();
                        if (this.createdRetreivalDialog) {
                            // Close the data retreival dialog
                            $dyn.shell.dialogBack();
                            this.createdRetreivalDialog = false;
                        }
                        this.retrievingGroupData = false;
                    }
                }
            };
            ReactList.prototype.createRetreivalDialog = function (complete) {
                var _this = this;
                $dyn.setValue(this, "dataRetrievalProgressText", $dyn.format($dyn.label("Grid_RowProcessed"), $dyn.length(this.DataSource)));
                var options = {
                    context: {
                        CancelClicked: function () {
                            _this.requestingData = false;
                            _this.retrievingGroupData = false;
                            complete && complete(true);
                        },
                        DisableAnimation: $dyn.flags.disableAnimations ? true : false,
                        ProgressText: this.dataRetrievalProgressText,
                        TitleText: $dyn.label("Grid_CalculatingTotals"),
                    },
                    role: "Dialog",
                    templateId: "ProgressMessage",
                };
                $dyn.shell.createForm(options);
                $dyn.shell.dialog(options);
                this.createdRetreivalDialog = true;
            };
            ReactList.prototype.setActiveRowCollectionIndex = function (index) {
                if (index >= 0 && $dyn.serverForm && $dyn.isServerBoundDataSource(this.DataSource)) {
                    var formId_4 = this.Root && this.Root.Id;
                    this.modelCollectionIds.forEach(function (collectionId) {
                        var collection = $dyn.serverForm.ModelManager.getModelCollection(collectionId, formId_4);
                        if (collection) {
                            var itemsLen = $dyn.length(collection.items);
                            if (itemsLen > 0 && index < itemsLen) {
                                var model = collection.items()[index];
                                if (model) {
                                    model.isSelected = true;
                                }
                            }
                        }
                    });
                }
            };
            ReactList.prototype.getUngroupAllButton = function (buttonStyle) {
                if (!this.ungroupAllButton) {
                    var buttonProps = {
                        key: UNGROUPALLBUTTONID,
                        Label: $dyn.label("Grid_UngroupAll"),
                        OnClick: this.ungroupAll,
                        Style: buttonStyle,
                    };
                    this.ungroupAllButton = React.createElement(ControlLibrary.Button, buttonProps);
                }
                return this.ungroupAllButton;
            };
            ReactList.prototype.getGroupHeaderLabelButton = function (buttonStyle) {
                if (!this.groupHeaderLabelButton) {
                    var buttonProps = {
                        key: GROUP_HEADER_LABEL_BUTTON_ID,
                        Label: $dyn.value(this.ShowGroupHeaderLabel) ? $dyn.label("ReactGrid_HideGroupHeaderLabel") : $dyn.label("ReactGrid_ShowGroupHeaderLabel"),
                        OnClick: this.toggleGroupHeaderLabel,
                        Style: buttonStyle,
                    };
                    this.groupHeaderLabelButton = React.createElement(ControlLibrary.Button, buttonProps);
                }
                return this.groupHeaderLabelButton;
            };
            ReactList.prototype.getAddColumnButton = function (buttonStyle) {
                if (!this.addColumnButton) {
                    var addColumnButtonProps = {
                        key: ADDCOLUMNBUTTONID,
                        Label: $dyn.label("ContextMenu_AddColumns"),
                        OnClick: this.addColumns,
                        Style: buttonStyle,
                    };
                    this.addColumnButton = React.createElement(ControlLibrary.Button, addColumnButtonProps);
                }
                return this.addColumnButton;
            };
            ReactList.prototype.getFooterButton = function (buttonStyle) {
                if (!this.footerButton) {
                    var isFooterShown = $dyn.value(this.FooterShown);
                    var footerButtonProps = {
                        key: FOOTERBUTTONID,
                        Label: isFooterShown ? $dyn.label("Grid_HideFooter") : $dyn.label("Grid_ShowFooter"),
                        OnClick: isFooterShown ? this.hideFooter : this.showFooter,
                        Style: buttonStyle,
                    };
                    this.footerButton = React.createElement(ControlLibrary.Button, footerButtonProps);
                }
                return this.footerButton;
            };
            Object.defineProperty(ReactList.prototype, "LookupRootStyle", {
                get: function () {
                    if (!this.lookupRootStyle) {
                        this.lookupRootStyle = { marginLeft: 0, marginTop: 0, marginRight: 0, marginBottom: 0 };
                    }
                    return this.lookupRootStyle;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ReactList.prototype, "InsideFastTabStyle", {
                get: function () {
                    if (!this.insideFastTabStyle) {
                        this.insideFastTabStyle = { marginTop: 0 };
                    }
                    return this.insideFastTabStyle;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ReactList.prototype, "InsideListPanelStyle", {
                get: function () {
                    if (!this.insideListPanelStyle) {
                        this.insideListPanelStyle = { minWidth: $dyn.ui.theme.getUnitValue("columnSize") };
                    }
                    return this.insideListPanelStyle;
                },
                enumerable: false,
                configurable: true
            });
            ReactList.prototype._getDefaultControl = function (rowElement) {
                var e_11, _a;
                var columns = $dyn.children(rowElement);
                var defaultControl;
                if (columns && !this.IsCardList()) {
                    try {
                        for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
                            var column = columns_1_1.value;
                            var control = $dyn.controlOptions(column);
                            if (control && CONTROL_SUPPORTS_DEFAULT_ACTION[control.TypeName]) {
                                if (!defaultControl) {
                                    defaultControl = control;
                                }
                                // Use IsDefaultActionGridControl if set
                                if ($dyn.value(control.IsDefaultActionGridControl)) {
                                    defaultControl = control;
                                    break;
                                }
                            }
                        }
                    }
                    catch (e_11_1) { e_11 = { error: e_11_1 }; }
                    finally {
                        try {
                            if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
                        }
                        finally { if (e_11) throw e_11.error; }
                    }
                }
                return defaultControl;
            };
            ReactList.prototype.IsCardList = function () {
                return $dyn.value(this.ExtendedStyle) === "cardList";
            };
            ReactList.prototype.performKeyDownNavigationAction = function (targetControl, event) {
                var _this = this;
                if ($dyn.length(this.DataSource) > 0 && $dyn.value(this.NavigationAction)) {
                    var callNavigationAction = false;
                    if (!$dyn.value(this.AllowEdit) && $dyn.value(this.Enabled) && $dyn.value(this.ForcePrimaryNavigation)) {
                        callNavigationAction = true;
                    }
                    else if ($dyn.value(this.NavigationEnabled) && (this.IsCardList() || this.defaultControlName === targetControl.Name)) {
                        callNavigationAction = true;
                    }
                    if (callNavigationAction) {
                        this.dataCache.turnOffFastFetch();
                        event.stopPropagation && event.stopPropagation();
                        event.preventDefault && event.preventDefault();
                        // Need this in a $dyn.async so that the potential SetValue command based off the enter is called first
                        $dyn.async(function () {
                            $dyn.callFunction(_this.NavigationAction, _this);
                        }, 0, "Calling navigation action on react grid");
                        return true;
                    }
                }
                return false;
            };
            ReactList.prototype.firstPotentialEditableColumn = function () {
                var e_12, _a;
                if (this.columnInfo) {
                    try {
                        for (var _b = __values(this.columnInfo), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var column = _c.value;
                            if ($dyn.value(column.Enabled) && column.TypeName !== "Image") {
                                return column._name;
                            }
                        }
                    }
                    catch (e_12_1) { e_12 = { error: e_12_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_12) throw e_12.error; }
                    }
                }
            };
            ReactList.prototype.setRowMark = function (collectionIndex, value, isServerBound) {
                if (isServerBound) {
                    $dyn.value(this.DataSource)[collectionIndex].isMarked = value;
                }
                else {
                    var row = $dyn.value(this.DataSource)[collectionIndex];
                    if (row[$dyn.reactGrid.ISMARKED_NAME] !== value) {
                        row[$dyn.reactGrid.ISMARKED_NAME] = value;
                        var parentGroupTrackingId = row[$dyn.reactGrid.PARENT_GROUP_KEY];
                        if (parentGroupTrackingId) {
                            this.groupingManager.adjustGroupMarkCount(parentGroupTrackingId, value ? 1 : -1);
                        }
                    }
                }
            };
            ReactList.prototype.getRowMark = function (collectionIndex, isServerBound) {
                if (isServerBound) {
                    return $dyn.value(this.DataSource)[collectionIndex].isMarked;
                }
                else {
                    return $dyn.value(this.DataSource)[collectionIndex][$dyn.reactGrid.ISMARKED_NAME];
                }
            };
            ReactList.prototype.clearRangeSelection = function () {
                this.rangeSelection = false;
                this.rangePivotTrackingId = "";
            };
            /**
             * Gets the map of data source name and field to array of control information.
             * @returns The map of data source name and field to array of control information.
             */
            ReactList.prototype.getDataSourceFieldToControlMap = function () {
                var e_13, _a;
                var map = {};
                try {
                    for (var _b = __values(this.columnInfo), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var columnInfo = _c.value;
                        var dataSourceMap = map[columnInfo.DataSourceName];
                        if (!dataSourceMap) {
                            dataSourceMap = {};
                            map[columnInfo.DataSourceName] = dataSourceMap;
                        }
                        var controlsArray = dataSourceMap[columnInfo.FieldName];
                        if (!controlsArray) {
                            controlsArray = [];
                            dataSourceMap[columnInfo.FieldName] = controlsArray;
                        }
                        controlsArray.push(columnInfo);
                    }
                }
                catch (e_13_1) { e_13 = { error: e_13_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_13) throw e_13.error; }
                }
                return map;
            };
            /**
             * Gets the property bag of column counts keyed by control name with the value returned from the provided value calculator.
             * @param valueCalculator The function used to calculate the value for a control with the control
             *                        information and data source provided as context.
             * @param dataSourceVisitor The function executed for each data source visited.
             * @returns The property bag of column counts keyed by control name with the value returned from the
             *          provided value calculator.
             */
            ReactList.prototype.getColumnCounts = function (valueCalculator, dataSourceVisitor) {
                var e_14, _a, e_15, _b;
                var columnCounts = {};
                var controlMap = this.getDataSourceFieldToControlMap();
                for (var dataSourceName in controlMap) {
                    if (controlMap.hasOwnProperty(dataSourceName)) {
                        var boundDataSource = void 0;
                        if ($dyn.isServerBoundDataSource(this.DataSource)) {
                            boundDataSource = $dyn.value(this.DataSource.__boundDataSource);
                            if (boundDataSource && boundDataSource.getRelatedCollection && dataSourceName !== boundDataSource.name) {
                                boundDataSource = boundDataSource.getRelatedCollection(dataSourceName);
                            }
                        }
                        if (boundDataSource) {
                            dataSourceVisitor && dataSourceVisitor(boundDataSource);
                            var fieldsWithTotals = $dyn.value(boundDataSource.fieldsWithTotals) || [];
                            var map = controlMap[dataSourceName];
                            try {
                                for (var fieldsWithTotals_1 = (e_14 = void 0, __values(fieldsWithTotals)), fieldsWithTotals_1_1 = fieldsWithTotals_1.next(); !fieldsWithTotals_1_1.done; fieldsWithTotals_1_1 = fieldsWithTotals_1.next()) {
                                    var fieldName = fieldsWithTotals_1_1.value;
                                    if (fieldName in map) {
                                        var columnControls = map[fieldName];
                                        try {
                                            for (var columnControls_1 = (e_15 = void 0, __values(columnControls)), columnControls_1_1 = columnControls_1.next(); !columnControls_1_1.done; columnControls_1_1 = columnControls_1.next()) {
                                                var control = columnControls_1_1.value;
                                                if (!this.countsExcludedControls[control._name]) {
                                                    columnCounts[control._name] = valueCalculator(control, boundDataSource);
                                                }
                                            }
                                        }
                                        catch (e_15_1) { e_15 = { error: e_15_1 }; }
                                        finally {
                                            try {
                                                if (columnControls_1_1 && !columnControls_1_1.done && (_b = columnControls_1.return)) _b.call(columnControls_1);
                                            }
                                            finally { if (e_15) throw e_15.error; }
                                        }
                                    }
                                }
                            }
                            catch (e_14_1) { e_14 = { error: e_14_1 }; }
                            finally {
                                try {
                                    if (fieldsWithTotals_1_1 && !fieldsWithTotals_1_1.done && (_a = fieldsWithTotals_1.return)) _a.call(fieldsWithTotals_1);
                                }
                                finally { if (e_14) throw e_14.error; }
                            }
                        }
                    }
                }
                return columnCounts;
            };
            /**
             * Gets the property bag of column counts keyed by control name with the calculated counts as the value.
             * @returns The property bag of column counts keyed by control name with the calculated counts as the value.
             */
            ReactList.prototype.getCalculatedColumnCounts = function () {
                var _this = this;
                this.gridCountVersions = {};
                return this.getColumnCounts(this.MayHaveMoreDataAboveOrBelow() || this.IsSizeLimited() || $dyn.length(this.DataSource) <= 0 ? ReactList.emptyValueCalculator : ReactList.valueCalculator, function (dataSource) {
                    if (!(dataSource.name in _this.gridCountVersions)) {
                        var totalsVersion_1 = dataSource.totalsVersion;
                        _this.gridCountVersions[dataSource.name] = function countsChanged() {
                            return totalsVersion_1 !== dataSource.totalsVersion;
                        };
                    }
                });
            };
            /**
             * Gets the property bag of column counts keyed by control name with null values.
             * @returnsThe property bag of column counts keyed by control name with null values.
             */
            ReactList.prototype.getEmptyColumnCounts = function () {
                this.gridCountVersions = {};
                return this.getColumnCounts(ReactList.emptyValueCalculator);
            };
            /**
             * Gets the marked row count.
             * @returns The marked row count.
             */
            ReactList.prototype.getMarkedRowCount = function () {
                return ($dyn.isServerBoundDataSource(this.DataSource) && $dyn.value(this.DataSource.__boundDataSource.markedCount)) || 0;
            };
            /**
             * Gets all the data for the grid data source.
             * @param complete The void, no-arg callback executed upon completion of data retrieval.
             */
            ReactList.prototype.getAllData = function (complete) {
                var _this = this;
                var pageRetrieved = function () {
                    if (_this.requestingData) {
                        $dyn.setValue(_this, "dataRetrievalProgressText", $dyn.format($dyn.label("Grid_RowProcessed"), $dyn.length(_this.DataSource)));
                        window.setTimeout(function () { _this.getAllData(complete); });
                    }
                };
                if ($dyn.value(this.IsSizeLimited)) {
                    this.requestingData = false;
                    complete && complete();
                }
                else if ($dyn.value(this.HasPreviousPage)) {
                    this.requestingData = true;
                    window.setTimeout(function () { _this.getPreviousPage(null, pageRetrieved); });
                }
                else if ($dyn.value(this.HasNextPage)) {
                    this.requestingData = true;
                    window.setTimeout(function () { _this.getNextPage(null, pageRetrieved); });
                }
                else {
                    this.requestingData = false;
                    complete && complete();
                }
            };
            /**
             * Updates whether the provided column's total should be shown in personalization.
             * @param columnName The name of the column to be adjusted.
             * @param shown Indicates whether the column total should be shown.
             */
            ReactList.prototype.updateColumnTotalShown = function (columnName, shown) {
                // Update the control's personalization indicating it can have a total shown
                var columnInfo = this.getColumnInfo(columnName);
                if ($dyn.value(columnInfo.UpdateTotalShown)) {
                    $dyn.callFunction(columnInfo.UpdateTotalShown, columnInfo, [shown]);
                }
            };
            ReactList.prototype.createOrShowColumnHeaderPopup = function (columnInfo) {
                // Use cached column header popup if available; otherwise create a new one, bind it, and cache it
                if (this.ColumnPopups[columnInfo._name]) {
                    var popupContext = $dyn.context(this.ColumnPopups[columnInfo._name].$popupElement[0]);
                    $dyn.setValue(popupContext, "IsSorted", $dyn.value(columnInfo.SortDirection));
                    var reorderElement = this.ColumnPopups[columnInfo._name].$reorderElement;
                    reorderElement && reorderElement.addClass("hasOpenPopup");
                    this.ColumnPopups[columnInfo._name].show(true);
                }
                else {
                    var $columnHeaderPopup = $("<div></div>");
                    // Gets unhidden after the get field filters command returns
                    $columnHeaderPopup[0].hidden = true;
                    $columnHeaderPopup.addClass("columnHeader-popup sysPopup");
                    $columnHeaderPopup.attr("data-dyn-role", "ColumnHeaderPopup");
                    var $headerElement_1 = $(this.element).find(".dyn-headerCell[data-dyn-controlname='" + columnInfo._name + "']"); // find column header element
                    var showPopup = $dyn.observable(false);
                    if (!this.FilterExpressions[columnInfo._name]) {
                        this.FilterExpressions[columnInfo._name] = $dyn.observable();
                    }
                    var data = {
                        ControlType: columnInfo.TypeName,
                        FieldName: columnInfo.FieldName,
                        FilterExpressions: this.FilterExpressions[columnInfo._name],
                        FlyOutPickerOpen: showPopup,
                        FormDataSourceName: columnInfo.DataSourceName,
                        IsSorted: $dyn.value(columnInfo.SortDirection),
                        Name: columnInfo._name,
                        Root: this.Root,
                    };
                    $dyn.dataBind($columnHeaderPopup[0], data);
                    var options_1 = {
                        flyout: $columnHeaderPopup,
                        positionResize: true,
                        putAnimationOnTarget: true,
                        scrollTarget: $(this.element),
                        show: showPopup,
                        target: $headerElement_1,
                    };
                    // put popup in flyout
                    $dyn.util.flyout(options_1, false);
                    var $reorderElement_1 = this.getReorderElement($headerElement_1);
                    // cache reorder element and show observable to be used next time header is opened
                    this.ColumnPopups[columnInfo._name] = {
                        $popupElement: $columnHeaderPopup,
                        $reorderElement: $reorderElement_1,
                        show: showPopup,
                    };
                    // Have to do this before opening flyout so it positions correctly
                    $reorderElement_1 && $reorderElement_1.addClass("hasOpenPopup");
                    showPopup(true);
                    var columnHeaderPopupContext_1 = $dyn.context($columnHeaderPopup[0]);
                    $dyn.observe(showPopup, function (value) {
                        if (value) {
                            $headerElement_1.addClass("hasOpenPopup");
                        }
                        else {
                            $headerElement_1.removeClass("hasOpenPopup");
                            $reorderElement_1 && $reorderElement_1.removeClass("hasOpenPopup");
                            // clear the aria label of the popup when it closes.
                            if (columnHeaderPopupContext_1) {
                                columnHeaderPopupContext_1.UpdateColumnHeaderAriaLabel(true);
                            }
                        }
                    });
                }
            };
            ReactList.prototype.getFieldFilterCallBack = function (columnInfo, updatePopup) {
                var _this = this;
                return function (fieldFilterArray) {
                    /// <summary>
                    /// The callback from the GetFieldFilter command. Updates the filterExpressions if the command returned valid filters.
                    /// </summary>
                    /// <param name="fieldFilterArray">A list of filterExpressions representing the filters for this column</param>
                    /// <returns type="boolean">True if the GetFieldFilter command returned valid filters</returns>
                    var validFiltersReturned = true;
                    if (fieldFilterArray && fieldFilterArray.length === _this.FilteringFields.length) {
                        // Array returned from the server should be the same length as the array sent from the client.
                        for (var i = 0; i < fieldFilterArray.length; i++) {
                            if (fieldFilterArray[i] && fieldFilterArray[i].Capability) {
                                var label_1 = $dyn.value(_this.FilteringFields[i].Label);
                                if (label_1) {
                                    // Override the field's label with the control's label in case the label has been overridden on the control level.
                                    $dyn.value(fieldFilterArray[i].Capability).FieldLabel = label_1;
                                }
                            }
                            else {
                                validFiltersReturned = false;
                                break;
                            }
                        }
                    }
                    else {
                        validFiltersReturned = false;
                    }
                    if (validFiltersReturned) {
                        // The filters returned are valid. Show the filters.
                        _this.updateFieldFilterExpressions(fieldFilterArray, columnInfo, updatePopup);
                    }
                    else {
                        // The filters returned are not valid. Close the flyout and log an error.
                        $dyn.error({ Message: $dyn.label("List_ColumnNotFilterable"), Label: "List_ColumnNotFilterable" }, _this);
                    }
                    return validFiltersReturned;
                };
            };
            ReactList.prototype.getReorderElement = function ($headerElement) {
                var $reorderElement;
                var $parent = $headerElement.closest(".public_fixedDataTableCell_hasReorderHandle");
                if ($parent.length) {
                    $reorderElement = $parent.find("> .fixedDataTableCellLayout_columnReorderContainer");
                }
                return $reorderElement;
            };
            /**
             * Update the FilterExpressions for this column. Note that this will make the FilterExpressions deeply observable, then show and databind the ColumnHeaderPopup.
             * @param newFilterExpressions A list of FieldFilterExpressions representing the filters for this column
             * @param columnInfo The column
             */
            ReactList.prototype.updateFieldFilterExpressions = function (newFilterExpressions, columnInfo, updatePopup) {
                var filterExpressions = newFilterExpressions;
                var observableSource;
                if (newFilterExpressions) {
                    var unwrappedFilterExpressions = $dyn.value(newFilterExpressions);
                    unwrappedFilterExpressions.forEach(function (filterExpression) {
                        // Convert the isEditable property from a string to a boolean
                        filterExpression.IsEditable = $dyn.util.stringToBoolean(filterExpression.IsEditable);
                    });
                    // Make filterExpressions deeply observable. Note that we cannot simply make all of the current members of the
                    // filterExpressions observable since actions such as changing to a multi-value operator would not cause the new values
                    // to be observable.
                    observableSource = unwrappedFilterExpressions;
                    var deeplyObservableFilterExpressions = $dyn.observableObject(unwrappedFilterExpressions);
                    filterExpressions = $dyn.value(deeplyObservableFilterExpressions);
                }
                // save filter expression in map by column
                if (this.FilterExpressions[columnInfo._name]) {
                    this.FilterExpressions[columnInfo._name](filterExpressions);
                    this.FilterExpressions[columnInfo._name].__source = observableSource;
                }
                if (updatePopup && this.ColumnPopups[columnInfo._name]) {
                    // Set the aria-label of the popup to describe the sorts and filters.
                    var columnHeaderPopupContext = $dyn.context(this.ColumnPopups[columnInfo._name].$popupElement[0]);
                    if (columnHeaderPopupContext) {
                        columnHeaderPopupContext.UpdateColumnHeaderAriaLabel();
                    }
                    this.ColumnPopups[columnInfo._name].$popupElement[0].hidden = false;
                }
            };
            Object.defineProperty(ReactList.prototype, "FilterManager", {
                get: function () {
                    if (!this.filterManager && this.Root) {
                        this.filterManager = this.Root.FilterManager;
                    }
                    return this.filterManager;
                },
                enumerable: false,
                configurable: true
            });
            ReactList.prototype.columnChanged = function () {
                var _this = this;
                // TODO: there has to be a more efficient way than recreating all children and re-rendering whole grid on column updates
                // TODO: optimize move logic on server, it currently sends down updates for all properties on all children
                $dyn.observe(this.creatingChildren, function (value) {
                    // Added observable so we can wait for extensible control resources to be loaded before re-creating the children
                    if (!value) {
                        _this.calculateChildrenAndRenderAsync();
                        // return false to disconnect observer
                        return false;
                    }
                });
            };
            ReactList.prototype.actOnDataBinding = function (columnOptions) {
                var _this = this;
                if (columnOptions._typeName === "ReferenceGroup") {
                    var refGroupElement = columnOptions._element || columnOptions.element;
                    if (refGroupElement && refGroupElement.dynChildren) {
                        var refDynChildren = refGroupElement.dynChildren();
                        if (refDynChildren.length > 0) {
                            // Should only need the first child of a ref group
                            var refGroupChildInfo = $dyn.controlOptions(refDynChildren[0]);
                            if (refGroupChildInfo) {
                                this.actOnDataBinding(refGroupChildInfo);
                            }
                        }
                    }
                }
                else if (columnOptions.DataSourceName && $dyn.isServerBoundDataSource(this.DataSource)) {
                    var differentDS = (columnOptions.DataSourceName !== this.DataSource.__dataSourceName);
                    var relatedCollection = differentDS ? this.DataSource.__boundDataSource.getRelatedCollection(columnOptions.DataSourceName) : this.DataSource.__boundDataSource;
                    if (relatedCollection) {
                        if (this.dataSourceObservers && differentDS && !this.dataSourceObservers[columnOptions.DataSourceName]) {
                            var dataSourceObserver = $dyn.observe(relatedCollection.items, function () {
                                _this.dataVersion++;
                                _this.renderReactListAsync();
                            }, this, undefined, true);
                            this.relatedItemSubscribers[relatedCollection.id] = relatedCollection.itemsChanged().subscribe(function () {
                                _this.dataVersion++;
                                _this.renderReactListAsync();
                            });
                            this.dataSourceObservers[columnOptions.DataSourceName] = dataSourceObserver;
                            this.modelCollectionIds.push(relatedCollection.id);
                        }
                    }
                    if (columnOptions.FieldName) {
                        if (this.gridCountVersions[columnOptions.DataSourceName]) {
                            delete this.gridCountVersions[columnOptions.DataSourceName];
                        }
                        this.gridCountVersions[columnOptions.DataSourceName] = function () { return true; };
                        if ($dyn.value(columnOptions.Enabled)) {
                            // Field maybe restricted, which is causing this control to be disabled.
                            // Thus this field will never be sent down and we would cause a refresh call on each calculate children
                            var itemsLength = relatedCollection.items().length;
                            if (itemsLength > 0) {
                                var firstItem = relatedCollection.items()[0];
                                var existsInFirstItem = firstItem.doesPropertyExist(columnOptions.FieldName);
                                var existsInLastItem = existsInFirstItem;
                                var existsInMiddleItem = existsInFirstItem;
                                if (itemsLength > 1) {
                                    var lastItem = relatedCollection.items()[itemsLength - 1];
                                    existsInLastItem = lastItem.doesPropertyExist(columnOptions.FieldName);
                                    if (itemsLength > 2) {
                                        var middleIndex = Math.floor((itemsLength - 1) / 2);
                                        var middleItem = relatedCollection.items()[middleIndex];
                                        existsInMiddleItem = middleItem.doesPropertyExist(columnOptions.FieldName);
                                    }
                                }
                                if (!existsInFirstItem || !existsInLastItem || !existsInMiddleItem) {
                                    if (!this.missingFields[relatedCollection.name]) {
                                        this.missingFields[relatedCollection.name] = {};
                                    }
                                    this.missingFields[relatedCollection.name][columnOptions.FieldName] = true;
                                }
                            }
                        }
                    }
                }
            };
            ReactList.prototype.handleMissingFields = function () {
                var _this = this;
                if (this.missingFields && Object.keys(this.missingFields).length > 0 && this.Refresh) {
                    // need to call in timeout so we don't try to queue this command while processing imcoming interactions
                    window.setTimeout(function () {
                        $dyn.log.reactList && $dyn.log.reactList("ReactList: Refresh data due to missing fields");
                        $dyn.callFunction(_this.Refresh, _this);
                    });
                }
            };
            ReactList.prototype.calculateChildrenAndRenderAsync = function () {
                var _this = this;
                if (this.calculateChildrenTimeout()) {
                    this.calculateChildrenTimeout().cancel();
                }
                // Try to batch multiple calls to render
                this.calculateChildrenTimeout($dyn.async(function () {
                    _this.calculateChildren(function () {
                        _this.groupingManager.updateGroupHeadersAndRerender();
                    });
                    _this.calculateChildrenTimeout(null);
                }, 0, "Call calculate children"));
            };
            ReactList.prototype.calculateChildren = function (callback) {
                var e_16, _a, e_17, _b, e_18, _c;
                var _this = this;
                this.columnInfo = [];
                this.columnNameToInfoIndex = {};
                this.missingFields = {};
                try {
                    for (var _d = __values(this.columnObservers), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var columnObserver = _e.value;
                        columnObserver.dispose();
                    }
                }
                catch (e_16_1) { e_16 = { error: e_16_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_16) throw e_16.error; }
                }
                this.columnObservers = [];
                var columnsOptions = this.getColumnsOptions();
                if (columnsOptions) {
                    this.creatingChildren(true);
                    var loadingResources = 0;
                    if ($dyn.value($dyn.util.controlLibraryResourcesLoaded)) {
                        loadingResources = $dyn.reactGrid.loadControlResources(columnsOptions, function () {
                            // this callback will be run if any resources are loaded.
                            _this.calculateChildren(callback);
                        });
                    }
                    else {
                        loadingResources = 1;
                        this.columnObservers.push($dyn.observe($dyn.util.controlLibraryResourcesLoaded, function (loaded) {
                            if (loaded) {
                                _this.calculateChildren(callback);
                            }
                        }));
                    }
                    if (loadingResources === 0) {
                        // No resources need to be loaded so calculate children synchronously.
                        this.calculatedAllowEdit = false;
                        this.hasFrozenChild = false;
                        try {
                            for (var columnsOptions_2 = __values(columnsOptions), columnsOptions_2_1 = columnsOptions_2.next(); !columnsOptions_2_1.done; columnsOptions_2_1 = columnsOptions_2.next()) {
                                var columnOptions = columnsOptions_2_1.value;
                                var visible = $dyn.value(columnOptions.Visible);
                                columnOptions.isInGrid = function () { return true; };
                                columnOptions.listControl = this;
                                columnOptions.Root = this.Root;
                                if (columnOptions.Name === undefined && columnOptions._name) {
                                    columnOptions.Name = columnOptions._name;
                                }
                                if (visible) {
                                    this.calculatedAllowEdit = (this.calculatedAllowEdit || $dyn.value(columnOptions.AllowEdit));
                                    this.hasFrozenChild = (this.hasFrozenChild || $dyn.value(columnOptions.IsFrozen));
                                    // Allow validation of these types in task recorder
                                    if (columnOptions.TypeName === "Input" ||
                                        columnOptions.TypeName === "ComboBox" ||
                                        columnOptions.TypeName === "CheckBox" ||
                                        columnOptions.TypeName === "Int64" ||
                                        columnOptions.TypeName === "Real" ||
                                        columnOptions.TypeName === "Date" ||
                                        columnOptions.TypeName === "Time" ||
                                        columnOptions.TypeName === "DateTime" ||
                                        columnOptions.TypeName === "Integer" ||
                                        columnOptions.TypeName === "MultilineInput") {
                                        columnOptions.recordability = $dyn.util.recordabilityDefault.bind(columnOptions);
                                    }
                                    if (columnOptions.TypeName === "Card") {
                                        var cardElement = columnOptions._element || columnOptions.element;
                                        var cardChildElements = cardElement.dynChildren();
                                        var cardChildOptions = cardChildElements.map(function (c) {
                                            return $dyn.controlOptions(c);
                                        });
                                        try {
                                            for (var cardChildOptions_1 = (e_18 = void 0, __values(cardChildOptions)), cardChildOptions_1_1 = cardChildOptions_1.next(); !cardChildOptions_1_1.done; cardChildOptions_1_1 = cardChildOptions_1.next()) {
                                                var cardChildOption = cardChildOptions_1_1.value;
                                                // TODO: factor this out to share things like react resources/contextmenu/observe ds
                                                if (cardChildOption.TypeName === "Toolbar") {
                                                    var toolbarElement = cardChildOption._element || cardChildOption.element;
                                                    var toolbarChildElements = toolbarElement.dynChildren();
                                                    toolbarChildElements.map(function (toolbarChildElement) {
                                                        var toolbarChildOptions = $dyn.controlOptions(toolbarChildElement);
                                                        if (toolbarChildOptions.TypeName === "ToolbarGroup") {
                                                            _this.columnObservers.push($dyn.bulkObserve(toolbarChildOptions, _this.columnChanged, $dyn.ui.updating, _this, undefined, COLUMN_PROPERTIES_TO_OBSERVE, true));
                                                            var toolbarGroupElement = toolbarChildOptions._element || toolbarChildOptions.element;
                                                            var toolbarGroupChildElements = toolbarGroupElement.dynChildren();
                                                            toolbarGroupChildElements.map(function (toolbarGroupChildElement) {
                                                                var toolbarGroupChildOptions = $dyn.controlOptions(toolbarGroupChildElement);
                                                                _this.columnObservers.push($dyn.bulkObserve(toolbarGroupChildOptions, _this.columnChanged, $dyn.ui.updating, _this, undefined, COLUMN_PROPERTIES_TO_OBSERVE, true));
                                                            });
                                                        }
                                                    });
                                                }
                                                else if (cardChildOption.TypeName === "MenuButton") {
                                                    cardChildOption.listControl = this;
                                                    if ($dyn.value(cardChildOption.HasBeenOpened)) {
                                                        var menuElement = cardChildOption._element || cardChildOption.element;
                                                        this.columnObservers.push($dyn.observe(menuElement.dynChildren, this.columnChanged, this, undefined, true));
                                                        var menuChildElements = $dyn.value(menuElement.dynChildren);
                                                        if (menuChildElements) {
                                                            menuChildElements.map(function (menuChildElement) {
                                                                var menuChildOptions = $dyn.controlOptions(menuChildElement);
                                                                _this.columnObservers.push($dyn.bulkObserve(menuChildOptions, _this.columnChanged, $dyn.ui.updating, _this, undefined, COLUMN_PROPERTIES_TO_OBSERVE, true));
                                                            });
                                                        }
                                                    }
                                                    else if ($dyn.isObservable(cardChildOption.HasBeenOpened)) {
                                                        this.columnObservers.push($dyn.observe(cardChildOption.HasBeenOpened, this.columnChanged, this, undefined, true));
                                                    }
                                                }
                                                if ($dyn.value(cardChildOption.Visible) !== false) {
                                                    this.columnNameToInfoIndex[cardChildOption._name] = this.columnInfo.length;
                                                    this.columnInfo.push(cardChildOption);
                                                }
                                            }
                                        }
                                        catch (e_18_1) { e_18 = { error: e_18_1 }; }
                                        finally {
                                            try {
                                                if (cardChildOptions_1_1 && !cardChildOptions_1_1.done && (_c = cardChildOptions_1.return)) _c.call(cardChildOptions_1);
                                            }
                                            finally { if (e_18) throw e_18.error; }
                                        }
                                    }
                                    else {
                                        columnOptions.addMessage = function (messageId, messageText) {
                                            if (this.messages) {
                                                this.messages.push(messageId);
                                            }
                                            else {
                                                this.messages = [messageId];
                                            }
                                            var listControl = this.listControl;
                                            // get current validity (need data source and collectionIndex)
                                            var collectionIndex = listControl.getCollectionIndexFromTrackingId($dyn.value(listControl.SelectedRowTrackingId));
                                            var validityValueKey = "_VIRTUALIZED_" + this._name + "_Validity";
                                            var newValidity = {
                                                messages: [messageText],
                                            };
                                            if ($dyn.isServerBoundDataSource(listControl.DataSource)) {
                                                var collectionData = $dyn.value(listControl.DataSource);
                                                var model = collectionData[collectionIndex];
                                                if (this.DataSourceName && collectionData[collectionIndex].collectionName !== this.DataSourceName) {
                                                    model = collectionData[collectionIndex].getRelated(this.DataSourceName, collectionIndex);
                                                }
                                                var validity = model.getValue(validityValueKey);
                                                // add it to validity messages (create validity object if empty)
                                                if (validity) {
                                                    if (validity.messages) {
                                                        validity.messages.push(messageText);
                                                    }
                                                    $dyn.util.objectAssign(newValidity, validity);
                                                }
                                                model.setValue(validityValueKey, newValidity, true, this.Root.Id);
                                                $dyn.reactGrid.appliedVirtualizedProperty = true;
                                            }
                                            else {
                                                var collectionData = $dyn.value(listControl.DataSource);
                                                var model = collectionData[collectionIndex];
                                                var validity = model[validityValueKey];
                                                // add it to validity messages (create validity object if empty)
                                                if (validity) {
                                                    if (validity.messages) {
                                                        validity.messages.push(messageText);
                                                    }
                                                    $dyn.util.objectAssign(newValidity, validity);
                                                }
                                                model[validityValueKey] = newValidity;
                                            }
                                        }.bind(columnOptions);
                                        // Integer and real controls always support totals (until metadata properties are introduced - VSTS#294293)
                                        columnOptions.AllowTotal = columnOptions.TypeName === "Real" || columnOptions.TypeName === "Integer";
                                        columnOptions.getContextMenuOptions = function () {
                                            var _this = this;
                                            var options = [];
                                            var listControl = this.listControl;
                                            if (listControl) {
                                                if ($dyn.value(this.IsFilterable) && $dyn.reactGrid.GroupingManager.flightEnabled()) {
                                                    // if grouping is already applied, append sort, otherwise clear
                                                    var currentGroupingDepth = $dyn.length(listControl.groupingManager.columnGrouping);
                                                    var clearSorts_1 = (currentGroupingDepth > 0) ? false : true;
                                                    var command = function () {
                                                        listControl.sort(_this, $dyn.ui.SortDirection.ascending, clearSorts_1, function () {
                                                            // Using concat to get a new array
                                                            var newGrouping = listControl.groupingManager.columnGrouping.concat([{ ControlName: _this._name }]);
                                                            listControl.groupingManager.group({ ColumnGroupings: newGrouping }, true);
                                                        });
                                                    };
                                                    var commandLabel = $dyn.label("Grid_GroupBy");
                                                    var enabled = currentGroupingDepth < $dyn.reactGrid.MAX_LEVEL_GROUPING;
                                                    // Ungroup if already grouped
                                                    var groupingIndex_1 = listControl.groupingManager.columnGrouping.findIndex(function (columnGrouping) { return columnGrouping.ControlName === _this._name; });
                                                    if (groupingIndex_1 > -1) {
                                                        command = function () {
                                                            if (groupingIndex_1 === 0) {
                                                                listControl.removeSort(listControl.groupingManager.columnGrouping);
                                                                listControl.groupingManager.group(null);
                                                            }
                                                            else {
                                                                // Remove column grouping
                                                                // Using slice to get a new array
                                                                var newGrouping = listControl.groupingManager.columnGrouping.slice(0, groupingIndex_1);
                                                                var removedGrouping = listControl.groupingManager.columnGrouping.slice(groupingIndex_1);
                                                                listControl.removeSort(removedGrouping);
                                                                listControl.groupingManager.group({ ColumnGroupings: newGrouping });
                                                            }
                                                        };
                                                        commandLabel = $dyn.label("Grid_Ungroup");
                                                        enabled = true;
                                                    }
                                                    options.push({
                                                        Command: command,
                                                        Enabled: enabled,
                                                        Label: commandLabel
                                                    });
                                                }
                                                if ($dyn.value(this.AllowTotal)) {
                                                    if ($dyn.value(listControl.FooterShown)) {
                                                        if ($dyn.value(this.TotalShown)) {
                                                            options.push({
                                                                Command: function () {
                                                                    listControl.requestRemoveTotalColumn(_this._name, null);
                                                                },
                                                                Label: $dyn.label("Grid_HideTotal"),
                                                            });
                                                        }
                                                        else {
                                                            options.push({
                                                                Command: function () {
                                                                    listControl.requestAddTotalColumn(_this._name, null, { performRender: true });
                                                                    listControl.requestTotalsFromControlLibrary();
                                                                },
                                                                Label: $dyn.label("Grid_TotalColumn"),
                                                            });
                                                        }
                                                    }
                                                    else {
                                                        if ($dyn.value(this.TotalShown)) {
                                                            options.push({
                                                                Command: function () {
                                                                    listControl.requestTotals(function (canceled) {
                                                                        if (!canceled) {
                                                                            listControl.showFooter();
                                                                        }
                                                                    });
                                                                },
                                                                Label: $dyn.label("Grid_TotalColumn"),
                                                            });
                                                        }
                                                        else {
                                                            options.push({
                                                                Command: function () {
                                                                    listControl.requestAddTotalColumn(_this._name, null, { performRender: true });
                                                                    listControl.requestTotals(function (canceled) {
                                                                        if (!canceled) {
                                                                            listControl.showFooter();
                                                                        }
                                                                    });
                                                                },
                                                                Label: $dyn.label("Grid_TotalColumn"),
                                                            });
                                                        }
                                                    }
                                                }
                                                if (listControl.Root) {
                                                    if ($dyn.value(listControl.Mode) === $dyn.ui.ListMode.tabular &&
                                                        $dyn.value(listControl.Root.AllowPersonalization) &&
                                                        $dyn.controls.ReactList.freezingEnabled()) {
                                                        var freezeCommand = void 0;
                                                        var freezeCommandLabel = "";
                                                        if ($dyn.value(this.IsFrozen)) {
                                                            freezeCommand = function () {
                                                                listControl.freezeColumn(_this._name, false);
                                                            };
                                                            freezeCommandLabel = $dyn.label("ContextMenu_UnfreezeColumn");
                                                        }
                                                        else {
                                                            freezeCommand = function () {
                                                                listControl.freezeColumn(_this._name, true);
                                                            };
                                                            freezeCommandLabel = $dyn.label("ContextMenu_FreezeColumn");
                                                        }
                                                        var freezeColumnOption = {
                                                            Command: freezeCommand,
                                                            Enabled: true,
                                                            Label: freezeCommandLabel
                                                        };
                                                        options.push(freezeColumnOption);
                                                    }
                                                    if ($dyn.value(listControl.Root.AllowExplicitPersonalization) && !listControl.Root.isPopup()) {
                                                        var hideColumnCommand = function () {
                                                            $dyn.callFunction(_this.ExecutePersonalizationCommand, _this, ["SelectForHide", false]);
                                                            $dyn.callFunction(_this.PersistPersonalization, _this, [$dyn.ax.personalizableProperties.Visible, false]);
                                                            if (listControl.Root && listControl.Root.ShowOrHideHiddenFields) {
                                                                listControl.Root.ShowOrHideHiddenFields(false);
                                                            }
                                                        };
                                                        var hideColumnOption = {
                                                            Command: hideColumnCommand,
                                                            Enabled: true,
                                                            Label: $dyn.label("ContextMenu_HideColumn"),
                                                        };
                                                        options.push(hideColumnOption);
                                                    }
                                                }
                                            }
                                            // TODO: Shortcuts are now defined in the control lib, need a copy for the View Shortcuts functionality?
                                            // Array.prototype.push.apply(options, $dyn.ui.Control.prototype.getContextMenuOptions.apply(this));
                                            return options;
                                        }.bind(columnOptions);
                                        var extraRegisteredProperties = $dyn.reactGrid.getControlProperties(columnOptions.TypeName);
                                        if (extraRegisteredProperties) {
                                            // create a new object
                                            var combinedPropertiesToObserve = $dyn.util.objectAssign({}, COLUMN_PROPERTIES_TO_OBSERVE, extraRegisteredProperties);
                                            // observer for any updates to individual columns
                                            this.columnObservers.push($dyn.bulkObserve(columnOptions, this.columnChanged, $dyn.ui.updating, this, undefined, combinedPropertiesToObserve, true));
                                        }
                                        else {
                                            // observer for any updates to individual columns
                                            this.columnObservers.push($dyn.bulkObserve(columnOptions, this.columnChanged, $dyn.ui.updating, this, undefined, COLUMN_PROPERTIES_TO_OBSERVE, true));
                                        }
                                        // observer for any updates to filtering on the columnOptions
                                        this.columnObservers.push($dyn.bulkObserve(columnOptions, this.updateFilterSortClasses, $dyn.ui.updating, this, undefined, COLUMN_FILTERSORT_PROPERTIES_TO_OBSERVE, true));
                                        if ($dyn.isObservable(columnOptions.IsValid)) {
                                            this.columnObservers.push($dyn.observe(columnOptions.IsValid, function (value) {
                                                var e_19, _a;
                                                var listControl = this.listControl;
                                                var rootId = "";
                                                if (this.Root) {
                                                    rootId = this.Root.Id;
                                                    if (this.Root.UpdateInvalidControlList) {
                                                        this.Root.UpdateInvalidControlList(this);
                                                    }
                                                }
                                                var validityRowId = $dyn.value(listControl.SelectedRowTrackingId);
                                                if (value) {
                                                    if ($dyn.length(this.messages) > 0) {
                                                        try {
                                                            for (var _b = __values(this.messages), _c = _b.next(); !_c.done; _c = _b.next()) {
                                                                var messageId = _c.value;
                                                                $dyn.messageManager.remove(messageId, rootId);
                                                            }
                                                        }
                                                        catch (e_19_1) { e_19 = { error: e_19_1 }; }
                                                        finally {
                                                            try {
                                                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                                            }
                                                            finally { if (e_19) throw e_19.error; }
                                                        }
                                                        this.messages = [];
                                                    }
                                                    listControl.syncManager.setValidity({ override: undefined, messages: [] }, validityRowId, this._name, this.DataSourceName);
                                                    listControl.syncManager.setDataVersion(validityRowId, this._name, this.DataSourceName);
                                                }
                                                else {
                                                    listControl.syncManager.setValidity({ override: false }, validityRowId, this._name, this.DataSourceName);
                                                }
                                            }, columnOptions, undefined, true));
                                        }
                                        // Need to observe any other DS's that the columns are bound to
                                        this.actOnDataBinding(columnOptions);
                                        if ($dyn.value(columnOptions.TotalShown)) {
                                            delete this.countsExcludedControls[columnOptions._name];
                                        }
                                        else {
                                            this.countsExcludedControls[columnOptions._name] = true;
                                        }
                                        if ($dyn.value(columnOptions.Visible) !== false) {
                                            this.columnNameToInfoIndex[columnOptions._name] = this.columnInfo.length;
                                            this.columnInfo.push(columnOptions);
                                        }
                                    }
                                }
                                else if ($dyn.isObservable(columnOptions.Visible)) {
                                    this.columnObservers.push($dyn.observe(columnOptions.Visible, this.columnChanged, this, undefined, true));
                                }
                            }
                        }
                        catch (e_17_1) { e_17 = { error: e_17_1 }; }
                        finally {
                            try {
                                if (columnsOptions_2_1 && !columnsOptions_2_1.done && (_b = columnsOptions_2.return)) _b.call(columnsOptions_2);
                            }
                            finally { if (e_17) throw e_17.error; }
                        }
                        this.handleMissingFields();
                        this.creatingChildren(false);
                        if (callback) {
                            callback();
                            callback = undefined;
                        }
                    }
                }
                else {
                    this.creatingChildren(false);
                    if (callback) {
                        callback();
                        callback = undefined;
                    }
                }
            };
            ReactList.prototype.updateFilterSortClasses = function () {
                var e_20, _a;
                try {
                    // Needed until we move the filtering/sorting into the control library
                    for (var _b = __values(this.columnInfo), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var colInfo = _c.value;
                        var $headerRow = $(this.element).find(".fixedDataTableLayout_rowsContainer > .fixedDataTableRowLayout_rowWrapper");
                        var $colHeader = $headerRow && $headerRow.find("[data-dyn-controlname='" + colInfo._name + "']");
                        if ($colHeader) {
                            var $colHeaderRole = $colHeader.closest("[role='columnheader']");
                            $colHeaderRole.attr("aria-sort", "none");
                            $colHeader.removeClass("isFilterable isFiltered sort-ascending sort-descending");
                            if ($dyn.value(colInfo.IsFilterable)) {
                                $colHeader.addClass("isFilterable");
                            }
                            if ($dyn.value(colInfo.IsFiltered)) {
                                $colHeader.addClass("isFiltered");
                            }
                            if ($dyn.value(colInfo.SortDirection) > -1 && $dyn.value(colInfo.IsPrimarySort)) {
                                var sortDirectionStr = $dyn.util.enumName($dyn.value(colInfo.SortDirection), $dyn.ui.SortDirection);
                                $colHeaderRole.attr("aria-sort", sortDirectionStr);
                                $colHeader.addClass("sort-" + sortDirectionStr);
                            }
                        }
                    }
                }
                catch (e_20_1) { e_20 = { error: e_20_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_20) throw e_20.error; }
                }
            };
            ReactList.prototype.renderReactList = function () {
                if (!this.element) {
                    return;
                }
                var insideListPanel = false;
                if (this._parent) {
                    var parentExtendedStyle = $dyn.value(this._parent.ExtendedStyle);
                    insideListPanel = (parentExtendedStyle === "listPanel_selPanel" || parentExtendedStyle === "listPanel_availPanel");
                }
                var activeRowIndex = this.getActiveRowIndex();
                var style;
                var rootElement = this.Root && this.Root.element;
                if (rootElement && rootElement.classList.contains("lookup-popup")) {
                    style = this.LookupRootStyle;
                }
                else if (this.element.parentElement && this.element.parentElement.classList.contains("section-container")) {
                    style = this.InsideFastTabStyle;
                }
                else if (insideListPanel) {
                    style = this.InsideListPanelStyle;
                }
                var isInEditMode;
                var gridLineType = $dyn.value(this.GridLines);
                if (this.Root) {
                    isInEditMode = !$dyn.value(this.Root.IsInViewMode);
                }
                var allowEdit = this.getAllowEditPropValue();
                var gridLines;
                switch (gridLineType) {
                    case $dyn.ui.GridLines.None:
                        gridLines = 0 /* none */;
                        break;
                    case $dyn.ui.GridLines.All:
                        gridLines = 2 /* all */;
                        break;
                    case $dyn.ui.GridLines.Vertical:
                        gridLines = 1 /* vertical */;
                        break;
                    default:
                        if (allowEdit && isInEditMode) {
                            gridLines = 2 /* all */;
                        }
                        else {
                            gridLines = 0 /* none */;
                        }
                }
                var isInSidePanel = false;
                // Check two parents up to check for sidepanel option
                if (this.element.parentElement &&
                    this.element.parentElement.parentElement &&
                    this.element.parentElement.parentElement.classList.contains("SidePanel")) {
                    isInSidePanel = true;
                }
                var parentArrangeMethod;
                var parentColumns = "";
                var parentWidth;
                if (this._parent) {
                    parentArrangeMethod = $dyn.value(this._parent.LayoutArrangeMethod);
                    parentColumns = $dyn.value(this._parent.Columns);
                    parentWidth = $dyn.value(this._parent.LayoutWidth);
                    if (typeof parentColumns !== "number" &&
                        parentColumns !== $dyn.layout.Columns.balanced &&
                        parentColumns !== $dyn.layout.Columns.fill &&
                        parentColumns !== $dyn.layout.Columns.limitHeight) {
                        // Columns could be a number string (like "1")
                        var columnsAsNumber = parseInt(parentColumns, 10);
                        if (!isNaN(columnsAsNumber)) {
                            parentColumns = columnsAsNumber;
                        }
                    }
                }
                var clientWidthMode = $dyn.value(this.LayoutWidth);
                var widthMode = "Manual" /* Manual */;
                var controlWidth = parseInt(clientWidthMode, 10);
                if (isNaN(controlWidth)) {
                    controlWidth = undefined;
                    // Convert from the client's sizing enum to the control library's sizing enum
                    widthMode = clientWidthMode === $dyn.layout.Size.available ? "SizeToAvailable" /* ToAvailable */ : "SizeToContent" /* ToContent */;
                    if (widthMode === "SizeToAvailable" /* ToAvailable */) {
                        var setWidthToContent = false;
                        if (!this.element.classList.contains("fill-width")) {
                            // Respect the fill-width class so our existing layout engine works
                            setWidthToContent = true;
                        }
                        if (!setWidthToContent &&
                            parentColumns && typeof parentColumns === "number" &&
                            parentArrangeMethod === $dyn.layout.ArrangeMethod.vertical &&
                            parentWidth === $dyn.layout.Size.content) {
                            // If parent columns are fixed and parent range method is vertical and parent width mode is size to content,
                            // grid width could drive the column width, so set width to content
                            setWidthToContent = true;
                        }
                        if (setWidthToContent) {
                            this.WidthOverride._current = true;
                            widthMode = "SizeToContent" /* ToContent */;
                        }
                    }
                }
                var clientHeightMode = $dyn.value(this.LayoutHeight);
                var heightMode = "Manual" /* Manual */;
                var controlHeight = parseInt(clientHeightMode, 10);
                if (isNaN(controlHeight)) {
                    // Need to pass undefined in so control library uses default sizing
                    controlHeight = undefined;
                    // Convert from the client's sizing enum to the control library's sizing enum
                    heightMode = clientHeightMode === $dyn.layout.Size.available ? "SizeToAvailable" /* ToAvailable */ : "SizeToContent" /* ToContent */;
                    var setHeightToContent = false;
                    // Workaround for ColumnMode=Fill or ColumnMode=Balanced or HorizontalWrap columns on the parent
                    if (parentColumns &&
                        (parentColumns === $dyn.layout.Columns.fill ||
                            parentColumns === $dyn.layout.Columns.balanced ||
                            parentArrangeMethod === $dyn.layout.ArrangeMethod.horizontalWrap)) {
                        setHeightToContent = true;
                    }
                    if (!setHeightToContent && (heightMode !== "SizeToAvailable" /* ToAvailable */ || $dyn.value(this.HeightOverride))) {
                        // if heightMode is anything else besides Available with VisibleRows set, make it size to content
                        // if layout set HeightOverride, make height mode size to content
                        setHeightToContent = true;
                    }
                    if (setHeightToContent) {
                        this.HeightOverride._current = true;
                        heightMode = "SizeToContent" /* ToContent */;
                    }
                }
                var mode = $dyn.value(this.Mode);
                if (mode === $dyn.ui.ListMode.list) {
                    controlWidth = $dyn.ui.theme.getUnitValue("smallCardWidth");
                    widthMode = "Manual" /* Manual */;
                    if (isInSidePanel) {
                        heightMode = "SizeToAvailable" /* ToAvailable */;
                    }
                }
                else if (this.gridCounts && $dyn.value(this.FooterShown)) {
                    var columnCounts = void 0;
                    for (var dataSourceName in this.gridCountVersions) {
                        if (this.gridCountVersions[dataSourceName]()) {
                            columnCounts = this.getCalculatedColumnCounts();
                            break;
                        }
                    }
                    if (columnCounts) {
                        this.gridCounts = $dyn.util.objectAssign({}, this.gridCounts, { ColumnCounts: columnCounts });
                    }
                }
                if (insideListPanel) {
                    controlHeight = 9 * $dyn.ui.theme.getUnitValue("gridUnit");
                    heightMode = "Manual" /* Manual */;
                    if ($dyn.length(this.DataSource) <= 0) {
                        controlWidth = $dyn.ui.theme.getUnitValue("columnSize");
                        widthMode = "Manual" /* Manual */;
                    }
                }
                var useDataId = $dyn.isServerBoundDataSource(this.DataSource);
                ReactDOM && ReactDOM.render(React.createElement($dyn.reactGrid.UI.ReactGrid, {
                    ActiveRowIndex: activeRowIndex,
                    AllowColumnReorder: (this.Root && $dyn.value(this.Root.AllowPersonalization)) ? true : false,
                    AllowEdit: allowEdit,
                    AllowMultipleMarking: $dyn.value(this.IsMarkingEnabled),
                    AllRowsMarked: $dyn.value(this.MarkAllRecords),
                    ClassName: $dyn.value(this.ExtendedStyle),
                    CollectionData: $dyn.value(this.DataSource),
                    CollectionDataLengthOffset: this.groupingManager.collectionLengthOffset(),
                    CollectionDataVersion: this.dataVersion,
                    ColumnInfo: this.columnInfo,
                    DataId: useDataId ? $dyn.reactGrid.MASTERTRACKINGID : undefined,
                    DefaultControl: this.defaultControlName,
                    Enabled: $dyn.value(this.Enabled),
                    EnhancedTabSequence: $dyn.util.isEnhancedTabSequenceEnabled(),
                    FooterInitiallyShown: $dyn.value(this.FooterShown),
                    ForceNavigationAction: $dyn.value(this.ForcePrimaryNavigation),
                    GetGridOptions: this.getGridOptions,
                    GetNextPage: this.getNextPage,
                    GetPreviousPage: this.getPreviousPage,
                    GetRowData: this.getRowData,
                    GridCounts: this.gridCounts,
                    GridLines: gridLines,
                    HasFixedChild: this.hasFrozenChild,
                    HasNextPage: $dyn.value(this.HasNextPage),
                    HasPreviousPage: $dyn.value(this.HasPreviousPage),
                    Height: controlHeight,
                    HeightMode: heightMode,
                    HideSelection: $dyn.value(this.HideSelection),
                    Id: this.Root ? this.Name + "_" + this.Root.Id : this.Name,
                    IsInSidePanel: isInSidePanel,
                    IsTabbingContainer: this.syncManager.RailsMode,
                    LoadDirection: this.dataCache.LoadDirection,
                    LoadingMessage: this.loadingMessage,
                    MarkedSelectedVersion: this.markedSelectedVersion,
                    Mode: $dyn.value(this.Mode),
                    Name: this.Name,
                    NavigationAction: this.executeAction,
                    NavigationEnabled: $dyn.value(this.NavigationEnabled),
                    NoResultsMessage: this.noResultsMessage,
                    OnColumnFocus: this.columnFocus,
                    OnColumnMouseEnter: this.columnMouseEnter,
                    OnColumnReorder: this.columnMove,
                    OnColumnResize: this.columnResize,
                    OnColumnSelected: this.columnSelected,
                    OnFooterVisibilityChange: this.footerVisibilityChange,
                    OnGroupHeaderClick: this.toggleGroupExpandCollapse,
                    OnKeyDown: this.onKeyDown,
                    OnLastRowArrowDown: this.lastRowArrowDown,
                    OnMouseEnter: this.mouseEnter,
                    OnMouseLeave: this.mouseLeave,
                    OnPaste: this.onPaste,
                    OnRequestAddTotalColumn: this.requestAddTotalColumn,
                    OnRequestGroupTotals: this.requestGroupTotals,
                    OnRequestRemoveTotalColumn: this.requestRemoveTotalColumn,
                    OnRequestTotals: this.requestTotals,
                    OnRowChange: this.changeRow,
                    OnRowClicked: this.onRowClicked,
                    OnScrollEnd: this.scrollEnd,
                    OnScrollStart: this.scrollStart,
                    OnSyncCellClicked: this.onSyncCellClicked,
                    OnSyncCellHover: this.onSyncCellHover,
                    PageBufferFactor: this.dataCache.PageBufferFactor,
                    PageSize: this.dataCache.PageSize < $dyn.length(this.DataSource) ? this.dataCache.PageSize : $dyn.length(this.DataSource),
                    PersonalizationMode: this.personalizationMode,
                    PostRender: this.postRender,
                    RecalculateSize: this.recalculateSize,
                    SetRef: this.setRef,
                    ShowGroupByColumn: $dyn.length(this.groupingManager.columnGrouping) > 0,
                    ShowHeader: $dyn.value(this.IsHeaderVisible),
                    ShowMarkingColumn: $dyn.value(this.IsSelectionIndicatorVisible),
                    Style: style,
                    ThemeVersion: this.themeVersion,
                    ToggleMark: this.toggleMark,
                    ToggleMarkAll: this.toggleMarkAll,
                    Type: "ReactGrid",
                    VisibleRowCount: $dyn.value(this.VisibleRowCount),
                    Width: controlWidth,
                    WidthMode: widthMode,
                }), this.element.querySelector(".reactGrid"));
            };
            ReactList.prototype.findSyncingColumn = function (event) {
                var targetElement = event.target;
                var foundElement = false;
                if (targetElement) {
                    do {
                        if (targetElement.classList && targetElement.classList.contains("dyn-syncingColumn")) {
                            foundElement = true;
                            break;
                        }
                        targetElement = targetElement.parentElement;
                    } while (targetElement && targetElement !== document.body);
                }
                return foundElement ? targetElement : undefined;
            };
            ReactList.prototype.IsInsidePreviewForm = function () {
                if (this.Root && this.Root.IsPreviewForm) {
                    return true;
                }
                return false;
            };
            /**
             * Exports the contents of this grid to Excel.
             * @param onlyMarkedRows Whether or not to limit the export to marked rows
             */
            ReactList.prototype.ExecuteExportToExcel = function (onlyMarkedRows) {
                $dyn.callFunction(this.ExportToExcel, this, onlyMarkedRows);
            };
            /**
             * Function checks if in zoom mode if we are changing row inside a sidepanel close the side panel if we are for responsive
             */
            ReactList.prototype.formActiveRowChangedNotify = function () {
                if ($dyn.util.isInZoomWidthMode() && this.isElementInSidePanel()) {
                    // close sidePanel
                    var sidePanel = this.Root.SidePanel;
                    if (sidePanel && sidePanel.SidePanelElement && $dyn.context(sidePanel.SidePanelElement).Visible) {
                        // trigger close
                        sidePanel.toggleVisibility();
                    }
                }
            };
            /**
             * Function checks if in element is in the side panel
             * @returns {boolean} true if in the sidePanel
             */
            ReactList.prototype.isElementInSidePanel = function () {
                if (this.elementInSidePanel === undefined) {
                    this.elementInSidePanel = false;
                    if (this.element && this.element.parentElement && this.element.parentElement.parentElement && this.element.parentElement.parentElement.classList.contains("SidePanel")) {
                        this.elementInSidePanel = true;
                    }
                }
                return this.elementInSidePanel;
            };
            return ReactList;
        }($dyn.ui.Control));
        controls.ReactList = ReactList;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ReactGrid.js.map
